(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
        typeof define === 'function' && define.amd ? define(['exports'], factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.IMask = {}));
})(this, (function (exports) { 'use strict';

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    var check = function (it) {
        return it && it.Math == Math && it;
    }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


    var global$p = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
        function () {
            return this;
        }() || Function('return this')();

    var objectGetOwnPropertyDescriptor = {};

    var fails$8 = function (exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };

    var fails$7 = fails$8; // Detect IE8's incomplete defineProperty implementation


    var descriptors = !fails$7(function () {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty({}, 1, {
            get: function () {
                return 7;
            }
        })[1] != 7;
    });

    var fails$6 = fails$8;

    var functionBindNative = !fails$6(function () {
        var test = function () {
            /* empty */
        }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


        return typeof test != 'function' || test.hasOwnProperty('prototype');
    });

    var NATIVE_BIND$1 = functionBindNative;

    var call$5 = Function.prototype.call;
    var functionCall = NATIVE_BIND$1 ? call$5.bind(call$5) : function () {
        return call$5.apply(call$5, arguments);
    };

    var objectPropertyIsEnumerable = {};

    var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

    var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

    var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({
        1: 2
    }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

    objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor$1(this, V);
        return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;

    var createPropertyDescriptor$2 = function (bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };

    var NATIVE_BIND = functionBindNative;

    var FunctionPrototype$1 = Function.prototype;
    var bind = FunctionPrototype$1.bind;
    var call$4 = FunctionPrototype$1.call;
    var uncurryThis$b = NATIVE_BIND && bind.bind(call$4, call$4);
    var functionUncurryThis = NATIVE_BIND ? function (fn) {
        return fn && uncurryThis$b(fn);
    } : function (fn) {
        return fn && function () {
            return call$4.apply(fn, arguments);
        };
    };

    var uncurryThis$a = functionUncurryThis;

    var toString$4 = uncurryThis$a({}.toString);
    var stringSlice$1 = uncurryThis$a(''.slice);

    var classofRaw$1 = function (it) {
        return stringSlice$1(toString$4(it), 8, -1);
    };

    var global$o = global$p;

    var uncurryThis$9 = functionUncurryThis;

    var fails$5 = fails$8;

    var classof$2 = classofRaw$1;

    var Object$4 = global$o.Object;
    var split = uncurryThis$9(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

    var indexedObject = fails$5(function () {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
        return !Object$4('z').propertyIsEnumerable(0);
    }) ? function (it) {
        return classof$2(it) == 'String' ? split(it, '') : Object$4(it);
    } : Object$4;

    var global$n = global$p;

    var TypeError$7 = global$n.TypeError; // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible

    var requireObjectCoercible$4 = function (it) {
        if (it == undefined) throw TypeError$7("Can't call method on " + it);
        return it;
    };

    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject$1 = indexedObject;

    var requireObjectCoercible$3 = requireObjectCoercible$4;

    var toIndexedObject$3 = function (it) {
        return IndexedObject$1(requireObjectCoercible$3(it));
    };

    // `IsCallable` abstract operation
    // https://tc39.es/ecma262/#sec-iscallable
    var isCallable$a = function (argument) {
        return typeof argument == 'function';
    };

    var isCallable$9 = isCallable$a;

    var isObject$5 = function (it) {
        return typeof it == 'object' ? it !== null : isCallable$9(it);
    };

    var global$m = global$p;

    var isCallable$8 = isCallable$a;

    var aFunction = function (argument) {
        return isCallable$8(argument) ? argument : undefined;
    };

    var getBuiltIn$3 = function (namespace, method) {
        return arguments.length < 2 ? aFunction(global$m[namespace]) : global$m[namespace] && global$m[namespace][method];
    };

    var uncurryThis$8 = functionUncurryThis;

    var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);

    var getBuiltIn$2 = getBuiltIn$3;

    var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

    var global$l = global$p;

    var userAgent$1 = engineUserAgent;

    var process = global$l.process;
    var Deno = global$l.Deno;
    var versions = process && process.versions || Deno && Deno.version;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
        match = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
        // but their correct versions are not interesting for us

        version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    } // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
    // so check `userAgent` even if `.v8` exists, but 0


    if (!version && userAgent$1) {
        match = userAgent$1.match(/Edge\/(\d+)/);

        if (!match || match[1] >= 74) {
            match = userAgent$1.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
        }
    }

    var engineV8Version = version;

    /* eslint-disable es/no-symbol -- required for testing */

    var V8_VERSION = engineV8Version;

    var fails$4 = fails$8; // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing


    var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$4(function () {
        var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
        // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

        return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
    });

    /* eslint-disable es/no-symbol -- required for testing */

    var NATIVE_SYMBOL$1 = nativeSymbol;

    var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';

    var global$k = global$p;

    var getBuiltIn$1 = getBuiltIn$3;

    var isCallable$7 = isCallable$a;

    var isPrototypeOf = objectIsPrototypeOf;

    var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

    var Object$3 = global$k.Object;
    var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
        return typeof it == 'symbol';
    } : function (it) {
        var $Symbol = getBuiltIn$1('Symbol');
        return isCallable$7($Symbol) && isPrototypeOf($Symbol.prototype, Object$3(it));
    };

    var global$j = global$p;

    var String$3 = global$j.String;

    var tryToString$1 = function (argument) {
        try {
            return String$3(argument);
        } catch (error) {
            return 'Object';
        }
    };

    var global$i = global$p;

    var isCallable$6 = isCallable$a;

    var tryToString = tryToString$1;

    var TypeError$6 = global$i.TypeError; // `Assert: IsCallable(argument) is true`

    var aCallable$1 = function (argument) {
        if (isCallable$6(argument)) return argument;
        throw TypeError$6(tryToString(argument) + ' is not a function');
    };

    var aCallable = aCallable$1; // `GetMethod` abstract operation
    // https://tc39.es/ecma262/#sec-getmethod


    var getMethod$1 = function (V, P) {
        var func = V[P];
        return func == null ? undefined : aCallable(func);
    };

    var global$h = global$p;

    var call$3 = functionCall;

    var isCallable$5 = isCallable$a;

    var isObject$4 = isObject$5;

    var TypeError$5 = global$h.TypeError; // `OrdinaryToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-ordinarytoprimitive

    var ordinaryToPrimitive$1 = function (input, pref) {
        var fn, val;
        if (pref === 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
        if (isCallable$5(fn = input.valueOf) && !isObject$4(val = call$3(fn, input))) return val;
        if (pref !== 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
        throw TypeError$5("Can't convert object to primitive value");
    };

    var shared$3 = {exports: {}};

    var global$g = global$p; // eslint-disable-next-line es/no-object-defineproperty -- safe


    var defineProperty$1 = Object.defineProperty;

    var setGlobal$3 = function (key, value) {
        try {
            defineProperty$1(global$g, key, {
                value: value,
                configurable: true,
                writable: true
            });
        } catch (error) {
            global$g[key] = value;
        }

        return value;
    };

    var global$f = global$p;

    var setGlobal$2 = setGlobal$3;

    var SHARED = '__core-js_shared__';
    var store$3 = global$f[SHARED] || setGlobal$2(SHARED, {});
    var sharedStore = store$3;

    var store$2 = sharedStore;

    (shared$3.exports = function (key, value) {
        return store$2[key] || (store$2[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: '3.21.0',
        mode: 'global',
        copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
        license: 'https://github.com/zloirock/core-js/blob/v3.21.0/LICENSE',
        source: 'https://github.com/zloirock/core-js'
    });

    var global$e = global$p;

    var requireObjectCoercible$2 = requireObjectCoercible$4;

    var Object$2 = global$e.Object; // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject

    var toObject$2 = function (argument) {
        return Object$2(requireObjectCoercible$2(argument));
    };

    var uncurryThis$7 = functionUncurryThis;

    var toObject$1 = toObject$2;

    var hasOwnProperty = uncurryThis$7({}.hasOwnProperty); // `HasOwnProperty` abstract operation
    // https://tc39.es/ecma262/#sec-hasownproperty

    var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
        return hasOwnProperty(toObject$1(it), key);
    };

    var uncurryThis$6 = functionUncurryThis;

    var id = 0;
    var postfix = Math.random();
    var toString$3 = uncurryThis$6(1.0.toString);

    var uid$2 = function (key) {
        return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id + postfix, 36);
    };

    var global$d = global$p;

    var shared$2 = shared$3.exports;

    var hasOwn$6 = hasOwnProperty_1;

    var uid$1 = uid$2;

    var NATIVE_SYMBOL = nativeSymbol;

    var USE_SYMBOL_AS_UID = useSymbolAsUid;

    var WellKnownSymbolsStore = shared$2('wks');
    var Symbol$1 = global$d.Symbol;
    var symbolFor = Symbol$1 && Symbol$1['for'];
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

    var wellKnownSymbol$3 = function (name) {
        if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
            var description = 'Symbol.' + name;

            if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
                WellKnownSymbolsStore[name] = Symbol$1[name];
            } else if (USE_SYMBOL_AS_UID && symbolFor) {
                WellKnownSymbolsStore[name] = symbolFor(description);
            } else {
                WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
            }
        }

        return WellKnownSymbolsStore[name];
    };

    var global$c = global$p;

    var call$2 = functionCall;

    var isObject$3 = isObject$5;

    var isSymbol$1 = isSymbol$2;

    var getMethod = getMethod$1;

    var ordinaryToPrimitive = ordinaryToPrimitive$1;

    var wellKnownSymbol$2 = wellKnownSymbol$3;

    var TypeError$4 = global$c.TypeError;
    var TO_PRIMITIVE = wellKnownSymbol$2('toPrimitive'); // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive

    var toPrimitive$1 = function (input, pref) {
        if (!isObject$3(input) || isSymbol$1(input)) return input;
        var exoticToPrim = getMethod(input, TO_PRIMITIVE);
        var result;

        if (exoticToPrim) {
            if (pref === undefined) pref = 'default';
            result = call$2(exoticToPrim, input, pref);
            if (!isObject$3(result) || isSymbol$1(result)) return result;
            throw TypeError$4("Can't convert object to primitive value");
        }

        if (pref === undefined) pref = 'number';
        return ordinaryToPrimitive(input, pref);
    };

    var toPrimitive = toPrimitive$1;

    var isSymbol = isSymbol$2; // `ToPropertyKey` abstract operation
    // https://tc39.es/ecma262/#sec-topropertykey


    var toPropertyKey$2 = function (argument) {
        var key = toPrimitive(argument, 'string');
        return isSymbol(key) ? key : key + '';
    };

    var global$b = global$p;

    var isObject$2 = isObject$5;

    var document$1 = global$b.document; // typeof document.createElement is 'object' in old IE

    var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

    var documentCreateElement = function (it) {
        return EXISTS$1 ? document$1.createElement(it) : {};
    };

    var DESCRIPTORS$6 = descriptors;

    var fails$3 = fails$8;

    var createElement = documentCreateElement; // Thanks to IE8 for its funny defineProperty


    var ie8DomDefine = !DESCRIPTORS$6 && !fails$3(function () {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty(createElement('div'), 'a', {
            get: function () {
                return 7;
            }
        }).a != 7;
    });

    var DESCRIPTORS$5 = descriptors;

    var call$1 = functionCall;

    var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;

    var createPropertyDescriptor$1 = createPropertyDescriptor$2;

    var toIndexedObject$2 = toIndexedObject$3;

    var toPropertyKey$1 = toPropertyKey$2;

    var hasOwn$5 = hasOwnProperty_1;

    var IE8_DOM_DEFINE$1 = ie8DomDefine; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


    var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

    objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject$2(O);
        P = toPropertyKey$1(P);
        if (IE8_DOM_DEFINE$1) try {
            return $getOwnPropertyDescriptor$1(O, P);
        } catch (error) {
            /* empty */
        }
        if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$1(propertyIsEnumerableModule$1.f, O, P), O[P]);
    };

    var objectDefineProperty = {};

    var DESCRIPTORS$4 = descriptors;

    var fails$2 = fails$8; // V8 ~ Chrome 36-
    // https://bugs.chromium.org/p/v8/issues/detail?id=3334


    var v8PrototypeDefineBug = DESCRIPTORS$4 && fails$2(function () {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty(function () {
            /* empty */
        }, 'prototype', {
            value: 42,
            writable: false
        }).prototype != 42;
    });

    var global$a = global$p;

    var isObject$1 = isObject$5;

    var String$2 = global$a.String;
    var TypeError$3 = global$a.TypeError; // `Assert: Type(argument) is Object`

    var anObject$2 = function (argument) {
        if (isObject$1(argument)) return argument;
        throw TypeError$3(String$2(argument) + ' is not an object');
    };

    var global$9 = global$p;

    var DESCRIPTORS$3 = descriptors;

    var IE8_DOM_DEFINE = ie8DomDefine;

    var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;

    var anObject$1 = anObject$2;

    var toPropertyKey = toPropertyKey$2;

    var TypeError$2 = global$9.TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

    var $defineProperty = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = 'enumerable';
    var CONFIGURABLE$1 = 'configurable';
    var WRITABLE = 'writable'; // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty

    objectDefineProperty.f = DESCRIPTORS$3 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
        anObject$1(O);
        P = toPropertyKey(P);
        anObject$1(Attributes);

        if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
            var current = $getOwnPropertyDescriptor(O, P);

            if (current && current[WRITABLE]) {
                O[P] = Attributes.value;
                Attributes = {
                    configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
                    enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                    writable: false
                };
            }
        }

        return $defineProperty(O, P, Attributes);
    } : $defineProperty : function defineProperty(O, P, Attributes) {
        anObject$1(O);
        P = toPropertyKey(P);
        anObject$1(Attributes);
        if (IE8_DOM_DEFINE) try {
            return $defineProperty(O, P, Attributes);
        } catch (error) {
            /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError$2('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };

    var DESCRIPTORS$2 = descriptors;

    var definePropertyModule$1 = objectDefineProperty;

    var createPropertyDescriptor = createPropertyDescriptor$2;

    var createNonEnumerableProperty$3 = DESCRIPTORS$2 ? function (object, key, value) {
        return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
        object[key] = value;
        return object;
    };

    var redefine$1 = {exports: {}};

    var uncurryThis$5 = functionUncurryThis;

    var isCallable$4 = isCallable$a;

    var store$1 = sharedStore;

    var functionToString = uncurryThis$5(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

    if (!isCallable$4(store$1.inspectSource)) {
        store$1.inspectSource = function (it) {
            return functionToString(it);
        };
    }

    var inspectSource$2 = store$1.inspectSource;

    var global$8 = global$p;

    var isCallable$3 = isCallable$a;

    var inspectSource$1 = inspectSource$2;

    var WeakMap$1 = global$8.WeakMap;
    var nativeWeakMap = isCallable$3(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

    var shared$1 = shared$3.exports;

    var uid = uid$2;

    var keys = shared$1('keys');

    var sharedKey$1 = function (key) {
        return keys[key] || (keys[key] = uid(key));
    };

    var hiddenKeys$3 = {};

    var NATIVE_WEAK_MAP = nativeWeakMap;

    var global$7 = global$p;

    var uncurryThis$4 = functionUncurryThis;

    var isObject = isObject$5;

    var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;

    var hasOwn$4 = hasOwnProperty_1;

    var shared = sharedStore;

    var sharedKey = sharedKey$1;

    var hiddenKeys$2 = hiddenKeys$3;

    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var TypeError$1 = global$7.TypeError;
    var WeakMap = global$7.WeakMap;
    var set$1, get, has;

    var enforce = function (it) {
        return has(it) ? get(it) : set$1(it, {});
    };

    var getterFor = function (TYPE) {
        return function (it) {
            var state;

            if (!isObject(it) || (state = get(it)).type !== TYPE) {
                throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
            }

            return state;
        };
    };

    if (NATIVE_WEAK_MAP || shared.state) {
        var store = shared.state || (shared.state = new WeakMap());
        var wmget = uncurryThis$4(store.get);
        var wmhas = uncurryThis$4(store.has);
        var wmset = uncurryThis$4(store.set);

        set$1 = function (it, metadata) {
            if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            wmset(store, it, metadata);
            return metadata;
        };

        get = function (it) {
            return wmget(store, it) || {};
        };

        has = function (it) {
            return wmhas(store, it);
        };
    } else {
        var STATE = sharedKey('state');
        hiddenKeys$2[STATE] = true;

        set$1 = function (it, metadata) {
            if (hasOwn$4(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            createNonEnumerableProperty$2(it, STATE, metadata);
            return metadata;
        };

        get = function (it) {
            return hasOwn$4(it, STATE) ? it[STATE] : {};
        };

        has = function (it) {
            return hasOwn$4(it, STATE);
        };
    }

    var internalState = {
        set: set$1,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
    };

    var DESCRIPTORS$1 = descriptors;

    var hasOwn$3 = hasOwnProperty_1;

    var FunctionPrototype = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

    var getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor;
    var EXISTS = hasOwn$3(FunctionPrototype, 'name'); // additional protection from minified / mangled / dropped function names

    var PROPER = EXISTS && function something() {
        /* empty */
    }.name === 'something';

    var CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || DESCRIPTORS$1 && getDescriptor(FunctionPrototype, 'name').configurable);
    var functionName = {
        EXISTS: EXISTS,
        PROPER: PROPER,
        CONFIGURABLE: CONFIGURABLE
    };

    var global$6 = global$p;

    var isCallable$2 = isCallable$a;

    var hasOwn$2 = hasOwnProperty_1;

    var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;

    var setGlobal$1 = setGlobal$3;

    var inspectSource = inspectSource$2;

    var InternalStateModule = internalState;

    var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;

    var getInternalState = InternalStateModule.get;
    var enforceInternalState = InternalStateModule.enforce;
    var TEMPLATE = String(String).split('String');
    (redefine$1.exports = function (O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var name = options && options.name !== undefined ? options.name : key;
        var state;

        if (isCallable$2(value)) {
            if (String(name).slice(0, 7) === 'Symbol(') {
                name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
            }

            if (!hasOwn$2(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                createNonEnumerableProperty$1(value, 'name', name);
            }

            state = enforceInternalState(value);

            if (!state.source) {
                state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
            }
        }

        if (O === global$6) {
            if (simple) O[key] = value;else setGlobal$1(key, value);
            return;
        } else if (!unsafe) {
            delete O[key];
        } else if (!noTargetGet && O[key]) {
            simple = true;
        }

        if (simple) O[key] = value;else createNonEnumerableProperty$1(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, 'toString', function toString() {
        return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
    });

    var objectGetOwnPropertyNames = {};

    var ceil$1 = Math.ceil;
    var floor = Math.floor; // `ToIntegerOrInfinity` abstract operation
    // https://tc39.es/ecma262/#sec-tointegerorinfinity

    var toIntegerOrInfinity$3 = function (argument) {
        var number = +argument; // eslint-disable-next-line no-self-compare -- safe

        return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil$1)(number);
    };

    var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

    var max = Math.max;
    var min$1 = Math.min; // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

    var toAbsoluteIndex$1 = function (index, length) {
        var integer = toIntegerOrInfinity$2(index);
        return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };

    var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

    var min = Math.min; // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength

    var toLength$2 = function (argument) {
        return argument > 0 ? min(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var toLength$1 = toLength$2; // `LengthOfArrayLike` abstract operation
    // https://tc39.es/ecma262/#sec-lengthofarraylike


    var lengthOfArrayLike$1 = function (obj) {
        return toLength$1(obj.length);
    };

    var toIndexedObject$1 = toIndexedObject$3;

    var toAbsoluteIndex = toAbsoluteIndex$1;

    var lengthOfArrayLike = lengthOfArrayLike$1; // `Array.prototype.{ indexOf, includes }` methods implementation


    var createMethod$1 = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
            var O = toIndexedObject$1($this);
            var length = lengthOfArrayLike(O);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check

            if (IS_INCLUDES && el != el) while (length > index) {
                value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

                if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };

    var arrayIncludes = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod$1(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod$1(false)
    };

    var uncurryThis$3 = functionUncurryThis;

    var hasOwn$1 = hasOwnProperty_1;

    var toIndexedObject = toIndexedObject$3;

    var indexOf = arrayIncludes.indexOf;

    var hiddenKeys$1 = hiddenKeys$3;

    var push = uncurryThis$3([].push);

    var objectKeysInternal = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) !hasOwn$1(hiddenKeys$1, key) && hasOwn$1(O, key) && push(result, key); // Don't enum bug & hidden keys


        while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
            ~indexOf(result, key) || push(result, key);
        }

        return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys$2 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

    var internalObjectKeys$1 = objectKeysInternal;

    var enumBugKeys$1 = enumBugKeys$2;

    var hiddenKeys = enumBugKeys$1.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe

    objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return internalObjectKeys$1(O, hiddenKeys);
    };

    var objectGetOwnPropertySymbols = {};

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

    var getBuiltIn = getBuiltIn$3;

    var uncurryThis$2 = functionUncurryThis;

    var getOwnPropertyNamesModule = objectGetOwnPropertyNames;

    var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;

    var anObject = anObject$2;

    var concat$1 = uncurryThis$2([].concat); // all object keys, includes non-enumerable and symbols

    var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = getOwnPropertyNamesModule.f(anObject(it));
        var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
        return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
    };

    var hasOwn = hasOwnProperty_1;

    var ownKeys = ownKeys$1;

    var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;

    var definePropertyModule = objectDefineProperty;

    var copyConstructorProperties$1 = function (target, source, exceptions) {
        var keys = ownKeys(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
                defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        }
    };

    var fails$1 = fails$8;

    var isCallable$1 = isCallable$a;

    var replacement = /#|\.prototype\./;

    var isForced$1 = function (feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : isCallable$1(detection) ? fails$1(detection) : !!detection;
    };

    var normalize = isForced$1.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced$1.data = {};
    var NATIVE = isForced$1.NATIVE = 'N';
    var POLYFILL = isForced$1.POLYFILL = 'P';
    var isForced_1 = isForced$1;

    var global$5 = global$p;

    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

    var createNonEnumerableProperty = createNonEnumerableProperty$3;

    var redefine = redefine$1.exports;

    var setGlobal = setGlobal$3;

    var copyConstructorProperties = copyConstructorProperties$1;

    var isForced = isForced_1;
    /*
     options.target      - name of the target object
     options.global      - target is the global object
     options.stat        - export as static methods of target
     options.proto       - export as prototype methods of target
     options.real        - real prototype method for the `pure` version
     options.forced      - export even if the native feature is available
     options.bind        - bind methods to the target, required for the `pure` version
     options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
     options.unsafe      - use the simple assignment of property instead of delete + defineProperty
     options.sham        - add a flag to not completely full polyfills
     options.enumerable  - export as enumerable property
     options.noTargetGet - prevent calling a getter on target
     options.name        - the .name of the function if it does not match the key
     */


    var _export = function (options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED, target, key, targetProperty, sourceProperty, descriptor;

        if (GLOBAL) {
            target = global$5;
        } else if (STATIC) {
            target = global$5[TARGET] || setGlobal(TARGET, {});
        } else {
            target = (global$5[TARGET] || {}).prototype;
        }

        if (target) for (key in source) {
            sourceProperty = source[key];

            if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor(target, key);
                targetProperty = descriptor && descriptor.value;
            } else targetProperty = target[key];

            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

            if (!FORCED && targetProperty !== undefined) {
                if (typeof sourceProperty == typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
            } // add a flag to not completely full polyfills


            if (options.sham || targetProperty && targetProperty.sham) {
                createNonEnumerableProperty(sourceProperty, 'sham', true);
            } // extend global


            redefine(target, key, sourceProperty, options);
        }
    };

    var internalObjectKeys = objectKeysInternal;

    var enumBugKeys = enumBugKeys$2; // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe


    var objectKeys$1 = Object.keys || function keys(O) {
        return internalObjectKeys(O, enumBugKeys);
    };

    var DESCRIPTORS = descriptors;

    var uncurryThis$1 = functionUncurryThis;

    var call = functionCall;

    var fails = fails$8;

    var objectKeys = objectKeys$1;

    var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;

    var propertyIsEnumerableModule = objectPropertyIsEnumerable;

    var toObject = toObject$2;

    var IndexedObject = indexedObject; // eslint-disable-next-line es/no-object-assign -- safe


    var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

    var defineProperty = Object.defineProperty;
    var concat = uncurryThis$1([].concat); // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign

    var objectAssign = !$assign || fails(function () {
        // should have correct order of operations (Edge bug)
        if (DESCRIPTORS && $assign({
            b: 1
        }, $assign(defineProperty({}, 'a', {
            enumerable: true,
            get: function () {
                defineProperty(this, 'b', {
                    value: 3,
                    enumerable: false
                });
            }
        }), {
            b: 2
        })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

        var A = {};
        var B = {}; // eslint-disable-next-line es/no-symbol -- safe

        var symbol = Symbol();
        var alphabet = 'abcdefghijklmnopqrst';
        A[symbol] = 7;
        alphabet.split('').forEach(function (chr) {
            B[chr] = chr;
        });
        return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
    }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars -- required for `.length`
        var T = toObject(target);
        var argumentsLength = arguments.length;
        var index = 1;
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        var propertyIsEnumerable = propertyIsEnumerableModule.f;

        while (argumentsLength > index) {
            var S = IndexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
                key = keys[j++];
                if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
            }
        }

        return T;
    } : $assign;

    var $$4 = _export;

    var assign = objectAssign; // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign
    // eslint-disable-next-line es/no-object-assign -- required for testing


    $$4({
        target: 'Object',
        stat: true,
        forced: Object.assign !== assign
    }, {
        assign: assign
    });

    var wellKnownSymbol$1 = wellKnownSymbol$3;

    var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
    var test = {};
    test[TO_STRING_TAG$1] = 'z';
    var toStringTagSupport = String(test) === '[object z]';

    var global$4 = global$p;

    var TO_STRING_TAG_SUPPORT = toStringTagSupport;

    var isCallable = isCallable$a;

    var classofRaw = classofRaw$1;

    var wellKnownSymbol = wellKnownSymbol$3;

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var Object$1 = global$4.Object; // ES3 wrong here

    var CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments;
    }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

    var tryGet = function (it, key) {
        try {
            return it[key];
        } catch (error) {
            /* empty */
        }
    }; // getting tag from ES6+ `Object.prototype.toString`


    var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
            : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag // builtinTag case
                : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
                    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
    };

    var global$3 = global$p;

    var classof = classof$1;

    var String$1 = global$3.String;

    var toString$2 = function (argument) {
        if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
        return String$1(argument);
    };

    var global$2 = global$p;

    var toIntegerOrInfinity = toIntegerOrInfinity$3;

    var toString$1 = toString$2;

    var requireObjectCoercible$1 = requireObjectCoercible$4;

    var RangeError = global$2.RangeError; // `String.prototype.repeat` method implementation
    // https://tc39.es/ecma262/#sec-string.prototype.repeat

    var stringRepeat = function repeat(count) {
        var str = toString$1(requireObjectCoercible$1(this));
        var result = '';
        var n = toIntegerOrInfinity(count);
        if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');

        for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;

        return result;
    };

    var $$3 = _export;

    var repeat$1 = stringRepeat; // `String.prototype.repeat` method
    // https://tc39.es/ecma262/#sec-string.prototype.repeat


    $$3({
        target: 'String',
        proto: true
    }, {
        repeat: repeat$1
    });

    // https://github.com/tc39/proposal-string-pad-start-end
    var uncurryThis = functionUncurryThis;

    var toLength = toLength$2;

    var toString = toString$2;

    var $repeat = stringRepeat;

    var requireObjectCoercible = requireObjectCoercible$4;

    var repeat = uncurryThis($repeat);
    var stringSlice = uncurryThis(''.slice);
    var ceil = Math.ceil; // `String.prototype.{ padStart, padEnd }` methods implementation

    var createMethod = function (IS_END) {
        return function ($this, maxLength, fillString) {
            var S = toString(requireObjectCoercible($this));
            var intMaxLength = toLength(maxLength);
            var stringLength = S.length;
            var fillStr = fillString === undefined ? ' ' : toString(fillString);
            var fillLen, stringFiller;
            if (intMaxLength <= stringLength || fillStr == '') return S;
            fillLen = intMaxLength - stringLength;
            stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
            if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
            return IS_END ? S + stringFiller : stringFiller + S;
        };
    };

    var stringPad = {
        // `String.prototype.padStart` method
        // https://tc39.es/ecma262/#sec-string.prototype.padstart
        start: createMethod(false),
        // `String.prototype.padEnd` method
        // https://tc39.es/ecma262/#sec-string.prototype.padend
        end: createMethod(true)
    };

    // https://github.com/zloirock/core-js/issues/280
    var userAgent = engineUserAgent;

    var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

    var $$2 = _export;

    var $padStart = stringPad.start;

    var WEBKIT_BUG$1 = stringPadWebkitBug; // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart


    $$2({
        target: 'String',
        proto: true,
        forced: WEBKIT_BUG$1
    }, {
        padStart: function padStart(maxLength
                                    /* , fillString = ' ' */
        ) {
            return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var $$1 = _export;

    var $padEnd = stringPad.end;

    var WEBKIT_BUG = stringPadWebkitBug; // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend


    $$1({
        target: 'String',
        proto: true,
        forced: WEBKIT_BUG
    }, {
        padEnd: function padEnd(maxLength
                                /* , fillString = ' ' */
        ) {
            return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var $ = _export;

    var global$1 = global$p; // `globalThis` object
    // https://tc39.es/ecma262/#sec-globalthis


    $({
        global: true
    }, {
        globalThis: global$1
    });

    function _typeof(obj) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
            return typeof obj;
        } : function (obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }

    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };

        return _setPrototypeOf(o, p);
    }

    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;

        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
            return true;
        } catch (e) {
            return false;
        }
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;

        for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }

        return target;
    }

    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};

        var target = _objectWithoutPropertiesLoose(source, excluded);

        var key, i;

        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }

        return target;
    }

    function _assertThisInitialized(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
    }

    function _possibleConstructorReturn(self, call) {
        if (call && (typeof call === "object" || typeof call === "function")) {
            return call;
        } else if (call !== void 0) {
            throw new TypeError("Derived constructors may only return object or undefined");
        }

        return _assertThisInitialized(self);
    }

    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();

        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived),
                result;

            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;

                result = Reflect.construct(Super, arguments, NewTarget);
            } else {
                result = Super.apply(this, arguments);
            }

            return _possibleConstructorReturn(this, result);
        };
    }

    function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = _getPrototypeOf(object);
            if (object === null) break;
        }

        return object;
    }

    function _get() {
        if (typeof Reflect !== "undefined" && Reflect.get) {
            _get = Reflect.get;
        } else {
            _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);

                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);

                if (desc.get) {
                    return desc.get.call(arguments.length < 3 ? target : receiver);
                }

                return desc.value;
            };
        }

        return _get.apply(this, arguments);
    }

    function set(target, property, value, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.set) {
            set = Reflect.set;
        } else {
            set = function set(target, property, value, receiver) {
                var base = _superPropBase(target, property);

                var desc;

                if (base) {
                    desc = Object.getOwnPropertyDescriptor(base, property);

                    if (desc.set) {
                        desc.set.call(receiver, value);
                        return true;
                    } else if (!desc.writable) {
                        return false;
                    }
                }

                desc = Object.getOwnPropertyDescriptor(receiver, property);

                if (desc) {
                    if (!desc.writable) {
                        return false;
                    }

                    desc.value = value;
                    Object.defineProperty(receiver, property, desc);
                } else {
                    _defineProperty(receiver, property, value);
                }

                return true;
            };
        }

        return set(target, property, value, receiver);
    }

    function _set(target, property, value, receiver, isStrict) {
        var s = set(target, property, value, receiver || target);

        if (!s && isStrict) {
            throw new Error('failed to set property');
        }

        return value;
    }

    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }

    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }

    function _iterableToArrayLimit(arr, i) {
        var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;

        var _s, _e;

        try {
            for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }

        return _arr;
    }

    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }

    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

        return arr2;
    }

    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    /**
     Provides details of changing model value
     @param {Object} [details]
     @param {string} [details.inserted] - Inserted symbols
     @param {boolean} [details.skip] - Can skip chars
     @param {number} [details.removeCount] - Removed symbols count
     @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
     */
    var ChangeDetails = /*#__PURE__*/function () {
        /** Inserted symbols */

        /** Can skip chars */

        /** Additional offset if any changes occurred before tail */

        /** Raw inserted is used by dynamic mask */
        function ChangeDetails(details) {
            _classCallCheck(this, ChangeDetails);

            Object.assign(this, {
                inserted: '',
                rawInserted: '',
                skip: false,
                tailShift: 0
            }, details);
        }
        /**
         Aggregate changes
         @returns {ChangeDetails} `this`
         */


        _createClass(ChangeDetails, [{
            key: "aggregate",
            value: function aggregate(details) {
                this.rawInserted += details.rawInserted;
                this.skip = this.skip || details.skip;
                this.inserted += details.inserted;
                this.tailShift += details.tailShift;
                return this;
            }
            /** Total offset considering all changes */

        }, {
            key: "offset",
            get: function get() {
                return this.tailShift + this.inserted.length;
            }
        }]);

        return ChangeDetails;
    }();

    /** Checks if value is string */

    function isString(str) {
        return typeof str === 'string' || str instanceof String;
    }
    /**
     Direction
     @prop {string} NONE
     @prop {string} LEFT
     @prop {string} FORCE_LEFT
     @prop {string} RIGHT
     @prop {string} FORCE_RIGHT
     */

    var DIRECTION = {
        NONE: 'NONE',
        LEFT: 'LEFT',
        FORCE_LEFT: 'FORCE_LEFT',
        RIGHT: 'RIGHT',
        FORCE_RIGHT: 'FORCE_RIGHT'
    };
    /** */

    function forceDirection(direction) {
        switch (direction) {
            case DIRECTION.LEFT:
                return DIRECTION.FORCE_LEFT;

            case DIRECTION.RIGHT:
                return DIRECTION.FORCE_RIGHT;

            default:
                return direction;
        }
    }
    /** Escapes regular expression control chars */

    function escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    }
    function normalizePrepare(prep) {
        return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
    } // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes

    function objectIncludes(b, a) {
        if (a === b) return true;
        var arrA = Array.isArray(a),
            arrB = Array.isArray(b),
            i;

        if (arrA && arrB) {
            if (a.length != b.length) return false;

            for (i = 0; i < a.length; i++) {
                if (!objectIncludes(a[i], b[i])) return false;
            }

            return true;
        }

        if (arrA != arrB) return false;

        if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
            var dateA = a instanceof Date,
                dateB = b instanceof Date;
            if (dateA && dateB) return a.getTime() == b.getTime();
            if (dateA != dateB) return false;
            var regexpA = a instanceof RegExp,
                regexpB = b instanceof RegExp;
            if (regexpA && regexpB) return a.toString() == b.toString();
            if (regexpA != regexpB) return false;
            var keys = Object.keys(a); // if (keys.length !== Object.keys(b).length) return false;

            for (i = 0; i < keys.length; i++) {
                // $FlowFixMe ... ???
                if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            }

            for (i = 0; i < keys.length; i++) {
                if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
            }

            return true;
        } else if (a && b && typeof a === 'function' && typeof b === 'function') {
            return a.toString() === b.toString();
        }

        return false;
    }
    /** Selection range */

    /** Provides details of changing input */

    var ActionDetails = /*#__PURE__*/function () {
        /** Current input value */

        /** Current cursor position */

        /** Old input value */

        /** Old selection */
        function ActionDetails(value, cursorPos, oldValue, oldSelection) {
            _classCallCheck(this, ActionDetails);

            this.value = value;
            this.cursorPos = cursorPos;
            this.oldValue = oldValue;
            this.oldSelection = oldSelection; // double check if left part was changed (autofilling, other non-standard input triggers)

            while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
                --this.oldSelection.start;
            }
        }
        /**
         Start changing position
         @readonly
         */


        _createClass(ActionDetails, [{
            key: "startChangePos",
            get: function get() {
                return Math.min(this.cursorPos, this.oldSelection.start);
            }
            /**
             Inserted symbols count
             @readonly
             */

        }, {
            key: "insertedCount",
            get: function get() {
                return this.cursorPos - this.startChangePos;
            }
            /**
             Inserted symbols
             @readonly
             */

        }, {
            key: "inserted",
            get: function get() {
                return this.value.substr(this.startChangePos, this.insertedCount);
            }
            /**
             Removed symbols count
             @readonly
             */

        }, {
            key: "removedCount",
            get: function get() {
                // Math.max for opposite operation
                return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
                    this.oldValue.length - this.value.length, 0);
            }
            /**
             Removed symbols
             @readonly
             */

        }, {
            key: "removed",
            get: function get() {
                return this.oldValue.substr(this.startChangePos, this.removedCount);
            }
            /**
             Unchanged head symbols
             @readonly
             */

        }, {
            key: "head",
            get: function get() {
                return this.value.substring(0, this.startChangePos);
            }
            /**
             Unchanged tail symbols
             @readonly
             */

        }, {
            key: "tail",
            get: function get() {
                return this.value.substring(this.startChangePos + this.insertedCount);
            }
            /**
             Remove direction
             @readonly
             */

        }, {
            key: "removeDirection",
            get: function get() {
                if (!this.removedCount || this.insertedCount) return DIRECTION.NONE; // align right if delete at right

                return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
                this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
            }
        }]);

        return ActionDetails;
    }();

    /** Provides details of continuous extracted tail */
    var ContinuousTailDetails = /*#__PURE__*/function () {
        /** Tail value as string */

        /** Tail start position */

        /** Start position */
        function ContinuousTailDetails() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var stop = arguments.length > 2 ? arguments[2] : undefined;

            _classCallCheck(this, ContinuousTailDetails);

            this.value = value;
            this.from = from;
            this.stop = stop;
        }

        _createClass(ContinuousTailDetails, [{
            key: "toString",
            value: function toString() {
                return this.value;
            }
        }, {
            key: "extend",
            value: function extend(tail) {
                this.value += String(tail);
            }
        }, {
            key: "appendTo",
            value: function appendTo(masked) {
                return masked.append(this.toString(), {
                    tail: true
                }).aggregate(masked._appendPlaceholder());
            }
        }, {
            key: "state",
            get: function get() {
                return {
                    value: this.value,
                    from: this.from,
                    stop: this.stop
                };
            },
            set: function set(state) {
                Object.assign(this, state);
            }
        }, {
            key: "unshift",
            value: function unshift(beforePos) {
                if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
                var shiftChar = this.value[0];
                this.value = this.value.slice(1);
                return shiftChar;
            }
        }, {
            key: "shift",
            value: function shift() {
                if (!this.value.length) return '';
                var shiftChar = this.value[this.value.length - 1];
                this.value = this.value.slice(0, -1);
                return shiftChar;
            }
        }]);

        return ContinuousTailDetails;
    }();

    /**
     * Applies mask on element.
     * @constructor
     * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
     * @param {Object} opts - Custom mask options
     * @return {InputMask}
     */
    function IMask(el) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // currently available only for input-like elements
        return new IMask.InputMask(el, opts);
    }

    /** Supported mask type */

    /** Provides common masking stuff */
    var Masked = /*#__PURE__*/function () {
        // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773

        /** @type {Mask} */

        /** */
        // $FlowFixMe no ideas

        /** Transforms value before mask processing */

        /** Validates if value is acceptable */

        /** Does additional processing in the end of editing */

        /** Format typed value to string */

        /** Parse strgin to get typed value */

        /** Enable characters overwriting */

        /** */

        /** */
        function Masked(opts) {
            _classCallCheck(this, Masked);

            this._value = '';

            this._update(Object.assign({}, Masked.DEFAULTS, opts));

            this.isInitialized = true;
        }
        /** Sets and applies new options */


        _createClass(Masked, [{
            key: "updateOptions",
            value: function updateOptions(opts) {
                if (!Object.keys(opts).length) return; // $FlowFixMe

                this.withValueRefresh(this._update.bind(this, opts));
            }
            /**
             Sets new options
             @protected
             */

        }, {
            key: "_update",
            value: function _update(opts) {
                Object.assign(this, opts);
            }
            /** Mask state */

        }, {
            key: "state",
            get: function get() {
                return {
                    _value: this.value
                };
            },
            set: function set(state) {
                this._value = state._value;
            }
            /** Resets value */

        }, {
            key: "reset",
            value: function reset() {
                this._value = '';
            }
            /** */

        }, {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(value) {
                this.resolve(value);
            }
            /** Resolve new value */

        }, {
            key: "resolve",
            value: function resolve(value) {
                this.reset();
                this.append(value, {
                    input: true
                }, '');
                this.doCommit();
                return this.value;
            }
            /** */

        }, {
            key: "unmaskedValue",
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.reset();
                this.append(value, {}, '');
                this.doCommit();
            }
            /** */

        }, {
            key: "typedValue",
            get: function get() {
                return this.doParse(this.value);
            },
            set: function set(value) {
                this.value = this.doFormat(value);
            }
            /** Value that includes raw user input */

        }, {
            key: "rawInputValue",
            get: function get() {
                return this.extractInput(0, this.value.length, {
                    raw: true
                });
            },
            set: function set(value) {
                this.reset();
                this.append(value, {
                    raw: true
                }, '');
                this.doCommit();
            }
            /** */

        }, {
            key: "isComplete",
            get: function get() {
                return true;
            }
            /** */

        }, {
            key: "isFilled",
            get: function get() {
                return this.isComplete;
            }
            /** Finds nearest input position in direction */

        }, {
            key: "nearestInputPos",
            value: function nearestInputPos(cursorPos, direction) {
                return cursorPos;
            }
            /** Extracts value in range considering flags */

        }, {
            key: "extractInput",
            value: function extractInput() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                return this.value.slice(fromPos, toPos);
            }
            /** Extracts tail in range */

        }, {
            key: "extractTail",
            value: function extractTail() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
            }
            /** Appends tail */
            // $FlowFixMe no ideas

        }, {
            key: "appendTail",
            value: function appendTail(tail) {
                if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
                return tail.appendTo(this);
            }
            /** Appends char */

        }, {
            key: "_appendCharRaw",
            value: function _appendCharRaw(ch) {
                if (!ch) return new ChangeDetails();
                this._value += ch;
                return new ChangeDetails({
                    inserted: ch,
                    rawInserted: ch
                });
            }
            /** Appends char */

        }, {
            key: "_appendChar",
            value: function _appendChar(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var checkTail = arguments.length > 2 ? arguments[2] : undefined;
                var consistentState = this.state;
                var details;

                var _normalizePrepare = normalizePrepare(this.doPrepare(ch, flags));

                var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);

                ch = _normalizePrepare2[0];
                details = _normalizePrepare2[1];
                details = details.aggregate(this._appendCharRaw(ch, flags));

                if (details.inserted) {
                    var consistentTail;
                    var appended = this.doValidate(flags) !== false;

                    if (appended && checkTail != null) {
                        // validation ok, check tail
                        var beforeTailState = this.state;

                        if (this.overwrite === true) {
                            consistentTail = checkTail.state;
                            checkTail.unshift(this.value.length);
                        }

                        var tailDetails = this.appendTail(checkTail);
                        appended = tailDetails.rawInserted === checkTail.toString(); // not ok, try shift

                        if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
                            this.state = beforeTailState;
                            consistentTail = checkTail.state;
                            checkTail.shift();
                            tailDetails = this.appendTail(checkTail);
                            appended = tailDetails.rawInserted === checkTail.toString();
                        } // if ok, rollback state after tail


                        if (appended && tailDetails.inserted) this.state = beforeTailState;
                    } // revert all if something went wrong


                    if (!appended) {
                        details = new ChangeDetails();
                        this.state = consistentState;
                        if (checkTail && consistentTail) checkTail.state = consistentTail;
                    }
                }

                return details;
            }
            /** Appends optional placeholder at end */

        }, {
            key: "_appendPlaceholder",
            value: function _appendPlaceholder() {
                return new ChangeDetails();
            }
            /** Appends optional eager placeholder at end */

        }, {
            key: "_appendEager",
            value: function _appendEager() {
                return new ChangeDetails();
            }
            /** Appends symbols considering flags */
            // $FlowFixMe no ideas

        }, {
            key: "append",
            value: function append(str, flags, tail) {
                if (!isString(str)) throw new Error('value should be string');
                var details = new ChangeDetails();
                var checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
                if (flags && flags.tail) flags._beforeTailState = this.state;

                for (var ci = 0; ci < str.length; ++ci) {
                    details.aggregate(this._appendChar(str[ci], flags, checkTail));
                } // append tail but aggregate only tailShift


                if (checkTail != null) {
                    details.tailShift += this.appendTail(checkTail).tailShift; // TODO it's a good idea to clear state after appending ends
                    // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
                    // this._resetBeforeTailState();
                }

                if (this.eager && flags !== null && flags !== void 0 && flags.input && str) {
                    details.aggregate(this._appendEager());
                }

                return details;
            }
            /** */

        }, {
            key: "remove",
            value: function remove() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
                return new ChangeDetails();
            }
            /** Calls function and reapplies current value */

        }, {
            key: "withValueRefresh",
            value: function withValueRefresh(fn) {
                if (this._refreshing || !this.isInitialized) return fn();
                this._refreshing = true;
                var rawInput = this.rawInputValue;
                var value = this.value;
                var ret = fn();
                this.rawInputValue = rawInput; // append lost trailing chars at end

                if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
                    this.append(value.slice(this.value.length), {}, '');
                }

                delete this._refreshing;
                return ret;
            }
            /** */

        }, {
            key: "runIsolated",
            value: function runIsolated(fn) {
                if (this._isolated || !this.isInitialized) return fn(this);
                this._isolated = true;
                var state = this.state;
                var ret = fn(this);
                this.state = state;
                delete this._isolated;
                return ret;
            }
            /**
             Prepares string before mask processing
             @protected
             */

        }, {
            key: "doPrepare",
            value: function doPrepare(str) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.prepare ? this.prepare(str, this, flags) : str;
            }
            /**
             Validates if value is acceptable
             @protected
             */

        }, {
            key: "doValidate",
            value: function doValidate(flags) {
                return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
            }
            /**
             Does additional processing in the end of editing
             @protected
             */

        }, {
            key: "doCommit",
            value: function doCommit() {
                if (this.commit) this.commit(this.value, this);
            }
            /** */

        }, {
            key: "doFormat",
            value: function doFormat(value) {
                return this.format ? this.format(value, this) : value;
            }
            /** */

        }, {
            key: "doParse",
            value: function doParse(str) {
                return this.parse ? this.parse(str, this) : str;
            }
            /** */

        }, {
            key: "splice",
            value: function splice(start, deleteCount, inserted, removeDirection) {
                var tailPos = start + deleteCount;
                var tail = this.extractTail(tailPos);
                var oldRawValue;

                if (this.eager) {
                    removeDirection = forceDirection(removeDirection);
                    oldRawValue = this.extractInput(0, tailPos, {
                        raw: true
                    });
                }

                var startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !this.eager ? DIRECTION.NONE : removeDirection);
                var details = new ChangeDetails({
                    tailShift: startChangePos - start // adjust tailShift if start was aligned

                }).aggregate(this.remove(startChangePos));

                if (this.eager && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
                    if (removeDirection === DIRECTION.FORCE_LEFT) {
                        var valLength;

                        while (oldRawValue === this.rawInputValue && (valLength = this.value.length)) {
                            details.aggregate(new ChangeDetails({
                                tailShift: -1
                            })).aggregate(this.remove(valLength - 1));
                        }
                    } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
                        tail.unshift();
                    }
                }

                return details.aggregate(this.append(inserted, {
                    input: true
                }, tail));
            }
        }, {
            key: "maskEquals",
            value: function maskEquals(mask) {
                return this.mask === mask;
            }
        }]);

        return Masked;
    }();
    Masked.DEFAULTS = {
        format: function format(v) {
            return v;
        },
        parse: function parse(v) {
            return v;
        }
    };
    IMask.Masked = Masked;

    /** Get Masked class by mask type */

    function maskedClass(mask) {
        if (mask == null) {
            throw new Error('mask property should be defined');
        } // $FlowFixMe


        if (mask instanceof RegExp) return IMask.MaskedRegExp; // $FlowFixMe

        if (isString(mask)) return IMask.MaskedPattern; // $FlowFixMe

        if (mask instanceof Date || mask === Date) return IMask.MaskedDate; // $FlowFixMe

        if (mask instanceof Number || typeof mask === 'number' || mask === Number) return IMask.MaskedNumber; // $FlowFixMe

        if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic; // $FlowFixMe

        if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask; // $FlowFixMe

        if (mask instanceof IMask.Masked) return mask.constructor; // $FlowFixMe

        if (mask instanceof Function) return IMask.MaskedFunction;
        console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
        // $FlowFixMe

        return IMask.Masked;
    }
    /** Creates new {@link Masked} depending on mask type */

    function createMask(opts) {
        // $FlowFixMe
        if (IMask.Masked && opts instanceof IMask.Masked) return opts;
        opts = Object.assign({}, opts);
        var mask = opts.mask; // $FlowFixMe

        if (IMask.Masked && mask instanceof IMask.Masked) return mask;
        var MaskedClass = maskedClass(mask);
        if (!MaskedClass) throw new Error('Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.');
        return new MaskedClass(opts);
    }
    IMask.createMask = createMask;

    var _excluded$4 = ["mask"];
    var DEFAULT_INPUT_DEFINITIONS = {
        '0': /\d/,
        'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
        // http://stackoverflow.com/a/22075070
        '*': /./
    };
    /** */

    var PatternInputDefinition = /*#__PURE__*/function () {
        /** */

        /** */

        /** */

        /** */

        /** */

        /** */

        /** */
        function PatternInputDefinition(opts) {
            _classCallCheck(this, PatternInputDefinition);

            var mask = opts.mask,
                blockOpts = _objectWithoutProperties(opts, _excluded$4);

            this.masked = createMask({
                mask: mask
            });
            Object.assign(this, blockOpts);
        }

        _createClass(PatternInputDefinition, [{
            key: "reset",
            value: function reset() {
                this.isFilled = false;
                this.masked.reset();
            }
        }, {
            key: "remove",
            value: function remove() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

                if (fromPos === 0 && toPos >= 1) {
                    this.isFilled = false;
                    return this.masked.remove(fromPos, toPos);
                }

                return new ChangeDetails();
            }
        }, {
            key: "value",
            get: function get() {
                return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
            }
        }, {
            key: "unmaskedValue",
            get: function get() {
                return this.masked.unmaskedValue;
            }
        }, {
            key: "isComplete",
            get: function get() {
                return Boolean(this.masked.value) || this.isOptional;
            }
        }, {
            key: "_appendChar",
            value: function _appendChar(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.isFilled) return new ChangeDetails();
                var state = this.masked.state; // simulate input

                var details = this.masked._appendChar(ch, flags);

                if (details.inserted && this.doValidate(flags) === false) {
                    details.inserted = details.rawInserted = '';
                    this.masked.state = state;
                }

                if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
                    details.inserted = this.placeholderChar;
                }

                details.skip = !details.inserted && !this.isOptional;
                this.isFilled = Boolean(details.inserted);
                return details;
            }
        }, {
            key: "append",
            value: function append() {
                var _this$masked;

                // TODO probably should be done via _appendChar
                return (_this$masked = this.masked).append.apply(_this$masked, arguments);
            }
        }, {
            key: "_appendPlaceholder",
            value: function _appendPlaceholder() {
                var details = new ChangeDetails();
                if (this.isFilled || this.isOptional) return details;
                this.isFilled = true;
                details.inserted = this.placeholderChar;
                return details;
            }
        }, {
            key: "_appendEager",
            value: function _appendEager() {
                return new ChangeDetails();
            }
        }, {
            key: "extractTail",
            value: function extractTail() {
                var _this$masked2;

                return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
            }
        }, {
            key: "appendTail",
            value: function appendTail() {
                var _this$masked3;

                return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
            }
        }, {
            key: "extractInput",
            value: function extractInput() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                var flags = arguments.length > 2 ? arguments[2] : undefined;
                return this.masked.extractInput(fromPos, toPos, flags);
            }
        }, {
            key: "nearestInputPos",
            value: function nearestInputPos(cursorPos) {
                var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                var minPos = 0;
                var maxPos = this.value.length;
                var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);

                switch (direction) {
                    case DIRECTION.LEFT:
                    case DIRECTION.FORCE_LEFT:
                        return this.isComplete ? boundPos : minPos;

                    case DIRECTION.RIGHT:
                    case DIRECTION.FORCE_RIGHT:
                        return this.isComplete ? boundPos : maxPos;

                    case DIRECTION.NONE:
                    default:
                        return boundPos;
                }
            }
        }, {
            key: "doValidate",
            value: function doValidate() {
                var _this$masked4, _this$parent;

                return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
            }
        }, {
            key: "doCommit",
            value: function doCommit() {
                this.masked.doCommit();
            }
        }, {
            key: "state",
            get: function get() {
                return {
                    masked: this.masked.state,
                    isFilled: this.isFilled
                };
            },
            set: function set(state) {
                this.masked.state = state.masked;
                this.isFilled = state.isFilled;
            }
        }]);

        return PatternInputDefinition;
    }();

    var PatternFixedDefinition = /*#__PURE__*/function () {
        /** */

        /** */

        /** */

        /** */

        /** */

        /** */
        function PatternFixedDefinition(opts) {
            _classCallCheck(this, PatternFixedDefinition);

            Object.assign(this, opts);
            this._value = '';
            this.isFixed = true;
        }

        _createClass(PatternFixedDefinition, [{
            key: "value",
            get: function get() {
                return this._value;
            }
        }, {
            key: "unmaskedValue",
            get: function get() {
                return this.isUnmasking ? this.value : '';
            }
        }, {
            key: "reset",
            value: function reset() {
                this._isRawInput = false;
                this._value = '';
            }
        }, {
            key: "remove",
            value: function remove() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
                this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
                if (!this._value) this._isRawInput = false;
                return new ChangeDetails();
            }
        }, {
            key: "nearestInputPos",
            value: function nearestInputPos(cursorPos) {
                var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                var minPos = 0;
                var maxPos = this._value.length;

                switch (direction) {
                    case DIRECTION.LEFT:
                    case DIRECTION.FORCE_LEFT:
                        return minPos;

                    case DIRECTION.NONE:
                    case DIRECTION.RIGHT:
                    case DIRECTION.FORCE_RIGHT:
                    default:
                        return maxPos;
                }
            }
        }, {
            key: "extractInput",
            value: function extractInput() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
                var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
            }
        }, {
            key: "isComplete",
            get: function get() {
                return true;
            }
        }, {
            key: "isFilled",
            get: function get() {
                return Boolean(this._value);
            }
        }, {
            key: "_appendChar",
            value: function _appendChar(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var details = new ChangeDetails();
                if (this._value) return details;
                var appended = this.char === ch;
                var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && !this.eager && !flags.tail;
                if (isResolved) details.rawInserted = this.char;
                this._value = details.inserted = this.char;
                this._isRawInput = isResolved && (flags.raw || flags.input);
                return details;
            }
        }, {
            key: "_appendEager",
            value: function _appendEager() {
                return this._appendChar(this.char);
            }
        }, {
            key: "_appendPlaceholder",
            value: function _appendPlaceholder() {
                var details = new ChangeDetails();
                if (this._value) return details;
                this._value = details.inserted = this.char;
                return details;
            }
        }, {
            key: "extractTail",
            value: function extractTail() {
                arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                return new ContinuousTailDetails('');
            } // $FlowFixMe no ideas

        }, {
            key: "appendTail",
            value: function appendTail(tail) {
                if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
                return tail.appendTo(this);
            }
        }, {
            key: "append",
            value: function append(str, flags, tail) {
                var details = this._appendChar(str[0], flags);

                if (tail != null) {
                    details.tailShift += this.appendTail(tail).tailShift;
                }

                return details;
            }
        }, {
            key: "doCommit",
            value: function doCommit() {}
        }, {
            key: "state",
            get: function get() {
                return {
                    _value: this._value,
                    _isRawInput: this._isRawInput
                };
            },
            set: function set(state) {
                Object.assign(this, state);
            }
        }]);

        return PatternFixedDefinition;
    }();

    var _excluded$3 = ["chunks"];

    var ChunksTailDetails = /*#__PURE__*/function () {
        /** */
        function ChunksTailDetails() {
            var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            _classCallCheck(this, ChunksTailDetails);

            this.chunks = chunks;
            this.from = from;
        }

        _createClass(ChunksTailDetails, [{
            key: "toString",
            value: function toString() {
                return this.chunks.map(String).join('');
            } // $FlowFixMe no ideas

        }, {
            key: "extend",
            value: function extend(tailChunk) {
                if (!String(tailChunk)) return;
                if (isString(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
                var lastChunk = this.chunks[this.chunks.length - 1];
                var extendLast = lastChunk && ( // if stops are same or tail has no stop
                    lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
                    tailChunk.from === lastChunk.from + lastChunk.toString().length;

                if (tailChunk instanceof ContinuousTailDetails) {
                    // check the ability to extend previous chunk
                    if (extendLast) {
                        // extend previous chunk
                        lastChunk.extend(tailChunk.toString());
                    } else {
                        // append new chunk
                        this.chunks.push(tailChunk);
                    }
                } else if (tailChunk instanceof ChunksTailDetails) {
                    if (tailChunk.stop == null) {
                        // unwrap floating chunks to parent, keeping `from` pos
                        var firstTailChunk;

                        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
                            firstTailChunk = tailChunk.chunks.shift();
                            firstTailChunk.from += tailChunk.from;
                            this.extend(firstTailChunk);
                        }
                    } // if tail chunk still has value


                    if (tailChunk.toString()) {
                        // if chunks contains stops, then popup stop to container
                        tailChunk.stop = tailChunk.blockIndex;
                        this.chunks.push(tailChunk);
                    }
                }
            }
        }, {
            key: "appendTo",
            value: function appendTo(masked) {
                // $FlowFixMe
                if (!(masked instanceof IMask.MaskedPattern)) {
                    var tail = new ContinuousTailDetails(this.toString());
                    return tail.appendTo(masked);
                }

                var details = new ChangeDetails();

                for (var ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
                    var chunk = this.chunks[ci];

                    var lastBlockIter = masked._mapPosToBlock(masked.value.length);

                    var stop = chunk.stop;
                    var chunkBlock = void 0;

                    if (stop != null && ( // if block not found or stop is behind lastBlock
                        !lastBlockIter || lastBlockIter.index <= stop)) {
                        if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
                            masked._stops.indexOf(stop) >= 0) {
                            details.aggregate(masked._appendPlaceholder(stop));
                        }

                        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
                    }

                    if (chunkBlock) {
                        var tailDetails = chunkBlock.appendTail(chunk);
                        tailDetails.skip = false; // always ignore skip, it will be set on last

                        details.aggregate(tailDetails);
                        masked._value += tailDetails.inserted; // get not inserted chars

                        var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                        if (remainChars) details.aggregate(masked.append(remainChars, {
                            tail: true
                        }));
                    } else {
                        details.aggregate(masked.append(chunk.toString(), {
                            tail: true
                        }));
                    }
                }
                return details;
            }
        }, {
            key: "state",
            get: function get() {
                return {
                    chunks: this.chunks.map(function (c) {
                        return c.state;
                    }),
                    from: this.from,
                    stop: this.stop,
                    blockIndex: this.blockIndex
                };
            },
            set: function set(state) {
                var chunks = state.chunks,
                    props = _objectWithoutProperties(state, _excluded$3);

                Object.assign(this, props);
                this.chunks = chunks.map(function (cstate) {
                    var chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails(); // $FlowFixMe already checked above

                    chunk.state = cstate;
                    return chunk;
                });
            }
        }, {
            key: "unshift",
            value: function unshift(beforePos) {
                if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
                var chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
                var ci = 0;

                while (ci < this.chunks.length) {
                    var chunk = this.chunks[ci];
                    var shiftChar = chunk.unshift(chunkShiftPos);

                    if (chunk.toString()) {
                        // chunk still contains value
                        // but not shifted - means no more available chars to shift
                        if (!shiftChar) break;
                        ++ci;
                    } else {
                        // clean if chunk has no value
                        this.chunks.splice(ci, 1);
                    }

                    if (shiftChar) return shiftChar;
                }

                return '';
            }
        }, {
            key: "shift",
            value: function shift() {
                if (!this.chunks.length) return '';
                var ci = this.chunks.length - 1;

                while (0 <= ci) {
                    var chunk = this.chunks[ci];
                    var shiftChar = chunk.shift();

                    if (chunk.toString()) {
                        // chunk still contains value
                        // but not shifted - means no more available chars to shift
                        if (!shiftChar) break;
                        --ci;
                    } else {
                        // clean if chunk has no value
                        this.chunks.splice(ci, 1);
                    }

                    if (shiftChar) return shiftChar;
                }

                return '';
            }
        }]);

        return ChunksTailDetails;
    }();

    var PatternCursor = /*#__PURE__*/function () {
        function PatternCursor(masked, pos) {
            _classCallCheck(this, PatternCursor);

            this.masked = masked;
            this._log = [];

            var _ref = masked._mapPosToBlock(pos) || (pos < 0 ? // first
                {
                    index: 0,
                    offset: 0
                } : // last
                {
                    index: this.masked._blocks.length,
                    offset: 0
                }),
                offset = _ref.offset,
                index = _ref.index;

            this.offset = offset;
            this.index = index;
            this.ok = false;
        }

        _createClass(PatternCursor, [{
            key: "block",
            get: function get() {
                return this.masked._blocks[this.index];
            }
        }, {
            key: "pos",
            get: function get() {
                return this.masked._blockStartPos(this.index) + this.offset;
            }
        }, {
            key: "state",
            get: function get() {
                return {
                    index: this.index,
                    offset: this.offset,
                    ok: this.ok
                };
            },
            set: function set(s) {
                Object.assign(this, s);
            }
        }, {
            key: "pushState",
            value: function pushState() {
                this._log.push(this.state);
            }
        }, {
            key: "popState",
            value: function popState() {
                var s = this._log.pop();

                this.state = s;
                return s;
            }
        }, {
            key: "bindBlock",
            value: function bindBlock() {
                if (this.block) return;

                if (this.index < 0) {
                    this.index = 0;
                    this.offset = 0;
                }

                if (this.index >= this.masked._blocks.length) {
                    this.index = this.masked._blocks.length - 1;
                    this.offset = this.block.value.length;
                }
            }
        }, {
            key: "_pushLeft",
            value: function _pushLeft(fn) {
                this.pushState();

                for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0) {
                    var _this$block;

                    if (fn()) return this.ok = true;
                }

                return this.ok = false;
            }
        }, {
            key: "_pushRight",
            value: function _pushRight(fn) {
                this.pushState();

                for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
                    if (fn()) return this.ok = true;
                }

                return this.ok = false;
            }
        }, {
            key: "pushLeftBeforeFilled",
            value: function pushLeftBeforeFilled() {
                var _this = this;

                return this._pushLeft(function () {
                    if (_this.block.isFixed || !_this.block.value) return;
                    _this.offset = _this.block.nearestInputPos(_this.offset, DIRECTION.FORCE_LEFT);
                    if (_this.offset !== 0) return true;
                });
            }
        }, {
            key: "pushLeftBeforeInput",
            value: function pushLeftBeforeInput() {
                var _this2 = this;

                // cases:
                // filled input: 00|
                // optional empty input: 00[]|
                // nested block: XX<[]>|
                return this._pushLeft(function () {
                    if (_this2.block.isFixed) return;
                    _this2.offset = _this2.block.nearestInputPos(_this2.offset, DIRECTION.LEFT);
                    return true;
                });
            }
        }, {
            key: "pushLeftBeforeRequired",
            value: function pushLeftBeforeRequired() {
                var _this3 = this;

                return this._pushLeft(function () {
                    if (_this3.block.isFixed || _this3.block.isOptional && !_this3.block.value) return;
                    _this3.offset = _this3.block.nearestInputPos(_this3.offset, DIRECTION.LEFT);
                    return true;
                });
            }
        }, {
            key: "pushRightBeforeFilled",
            value: function pushRightBeforeFilled() {
                var _this4 = this;

                return this._pushRight(function () {
                    if (_this4.block.isFixed || !_this4.block.value) return;
                    _this4.offset = _this4.block.nearestInputPos(_this4.offset, DIRECTION.FORCE_RIGHT);
                    if (_this4.offset !== _this4.block.value.length) return true;
                });
            }
        }, {
            key: "pushRightBeforeInput",
            value: function pushRightBeforeInput() {
                var _this5 = this;

                return this._pushRight(function () {
                    if (_this5.block.isFixed) return; // const o = this.offset;

                    _this5.offset = _this5.block.nearestInputPos(_this5.offset, DIRECTION.NONE); // HACK cases like (STILL DOES NOT WORK FOR NESTED)
                    // aa|X
                    // aa<X|[]>X_    - this will not work
                    // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;

                    return true;
                });
            }
        }, {
            key: "pushRightBeforeRequired",
            value: function pushRightBeforeRequired() {
                var _this6 = this;

                return this._pushRight(function () {
                    if (_this6.block.isFixed || _this6.block.isOptional && !_this6.block.value) return; // TODO check |[*]XX_

                    _this6.offset = _this6.block.nearestInputPos(_this6.offset, DIRECTION.NONE);
                    return true;
                });
            }
        }]);

        return PatternCursor;
    }();

    /** Masking by RegExp */

    var MaskedRegExp = /*#__PURE__*/function (_Masked) {
        _inherits(MaskedRegExp, _Masked);

        var _super = _createSuper(MaskedRegExp);

        function MaskedRegExp() {
            _classCallCheck(this, MaskedRegExp);

            return _super.apply(this, arguments);
        }

        _createClass(MaskedRegExp, [{
            key: "_update",
            value:
                /**
                 @override
                 @param {Object} opts
                 */
                function _update(opts) {
                    if (opts.mask) opts.validate = function (value) {
                        return value.search(opts.mask) >= 0;
                    };

                    _get(_getPrototypeOf(MaskedRegExp.prototype), "_update", this).call(this, opts);
                }
        }]);

        return MaskedRegExp;
    }(Masked);
    IMask.MaskedRegExp = MaskedRegExp;

    var _excluded$2 = ["_blocks"];

    /**
     Pattern mask
     @param {Object} opts
     @param {Object} opts.blocks
     @param {Object} opts.definitions
     @param {string} opts.placeholderChar
     @param {boolean} opts.lazy
     */
    var MaskedPattern = /*#__PURE__*/function (_Masked) {
        _inherits(MaskedPattern, _Masked);

        var _super = _createSuper(MaskedPattern);

        /** */

        /** */

        /** Single char for empty input */

        /** Show placeholder only when needed */
        function MaskedPattern() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, MaskedPattern);

            // TODO type $Shape<MaskedPatternOptions>={} does not work
            opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
            return _super.call(this, Object.assign({}, MaskedPattern.DEFAULTS, opts));
        }
        /**
         @override
         @param {Object} opts
         */


        _createClass(MaskedPattern, [{
            key: "_update",
            value: function _update() {
                var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                opts.definitions = Object.assign({}, this.definitions, opts.definitions);

                _get(_getPrototypeOf(MaskedPattern.prototype), "_update", this).call(this, opts);

                this._rebuildMask();
            }
            /** */

        }, {
            key: "_rebuildMask",
            value: function _rebuildMask() {
                var _this = this;

                var defs = this.definitions;
                this._blocks = [];
                this._stops = [];
                this._maskedBlocks = {};
                var pattern = this.mask;
                if (!pattern || !defs) return;
                var unmaskingBlock = false;
                var optionalBlock = false;

                for (var i = 0; i < pattern.length; ++i) {
                    if (this.blocks) {
                        var _ret = function () {
                            var p = pattern.slice(i);
                            var bNames = Object.keys(_this.blocks).filter(function (bName) {
                                return p.indexOf(bName) === 0;
                            }); // order by key length

                            bNames.sort(function (a, b) {
                                return b.length - a.length;
                            }); // use block name with max length

                            var bName = bNames[0];

                            if (bName) {
                                // $FlowFixMe no ideas
                                var maskedBlock = createMask(Object.assign({
                                    parent: _this,
                                    lazy: _this.lazy,
                                    eager: _this.eager,
                                    placeholderChar: _this.placeholderChar,
                                    overwrite: _this.overwrite
                                }, _this.blocks[bName]));

                                if (maskedBlock) {
                                    _this._blocks.push(maskedBlock); // store block index


                                    if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];

                                    _this._maskedBlocks[bName].push(_this._blocks.length - 1);
                                }

                                i += bName.length - 1;
                                return "continue";
                            }
                        }();

                        if (_ret === "continue") continue;
                    }

                    var char = pattern[i];
                    var isInput = (char in defs);

                    if (char === MaskedPattern.STOP_CHAR) {
                        this._stops.push(this._blocks.length);

                        continue;
                    }

                    if (char === '{' || char === '}') {
                        unmaskingBlock = !unmaskingBlock;
                        continue;
                    }

                    if (char === '[' || char === ']') {
                        optionalBlock = !optionalBlock;
                        continue;
                    }

                    if (char === MaskedPattern.ESCAPE_CHAR) {
                        ++i;
                        char = pattern[i];
                        if (!char) break;
                        isInput = false;
                    }

                    var def = isInput ? new PatternInputDefinition({
                        parent: this,
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        mask: defs[char],
                        isOptional: optionalBlock
                    }) : new PatternFixedDefinition({
                        char: char,
                        eager: this.eager,
                        isUnmasking: unmaskingBlock
                    });

                    this._blocks.push(def);
                }
            }
            /**
             @override
             */

        }, {
            key: "state",
            get: function get() {
                return Object.assign({}, _get(_getPrototypeOf(MaskedPattern.prototype), "state", this), {
                    _blocks: this._blocks.map(function (b) {
                        return b.state;
                    })
                });
            },
            set: function set(state) {
                var _blocks = state._blocks,
                    maskedState = _objectWithoutProperties(state, _excluded$2);

                this._blocks.forEach(function (b, bi) {
                    return b.state = _blocks[bi];
                });

                _set(_getPrototypeOf(MaskedPattern.prototype), "state", maskedState, this, true);
            }
            /**
             @override
             */

        }, {
            key: "reset",
            value: function reset() {
                _get(_getPrototypeOf(MaskedPattern.prototype), "reset", this).call(this);

                this._blocks.forEach(function (b) {
                    return b.reset();
                });
            }
            /**
             @override
             */

        }, {
            key: "isComplete",
            get: function get() {
                return this._blocks.every(function (b) {
                    return b.isComplete;
                });
            }
            /**
             @override
             */

        }, {
            key: "isFilled",
            get: function get() {
                return this._blocks.every(function (b) {
                    return b.isFilled;
                });
            }
        }, {
            key: "isFixed",
            get: function get() {
                return this._blocks.every(function (b) {
                    return b.isFixed;
                });
            }
        }, {
            key: "isOptional",
            get: function get() {
                return this._blocks.every(function (b) {
                    return b.isOptional;
                });
            }
            /**
             @override
             */

        }, {
            key: "doCommit",
            value: function doCommit() {
                this._blocks.forEach(function (b) {
                    return b.doCommit();
                });

                _get(_getPrototypeOf(MaskedPattern.prototype), "doCommit", this).call(this);
            }
            /**
             @override
             */

        }, {
            key: "unmaskedValue",
            get: function get() {
                return this._blocks.reduce(function (str, b) {
                    return str += b.unmaskedValue;
                }, '');
            },
            set: function set(unmaskedValue) {
                _set(_getPrototypeOf(MaskedPattern.prototype), "unmaskedValue", unmaskedValue, this, true);
            }
            /**
             @override
             */

        }, {
            key: "value",
            get: function get() {
                // TODO return _value when not in change?
                return this._blocks.reduce(function (str, b) {
                    return str += b.value;
                }, '');
            },
            set: function set(value) {
                _set(_getPrototypeOf(MaskedPattern.prototype), "value", value, this, true);
            }
            /**
             @override
             */

        }, {
            key: "appendTail",
            value: function appendTail(tail) {
                return _get(_getPrototypeOf(MaskedPattern.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
            }
            /**
             @override
             */

        }, {
            key: "_appendEager",
            value: function _appendEager() {
                var _this$_mapPosToBlock;

                var details = new ChangeDetails();
                var startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
                if (startBlockIndex == null) return details; // TODO test if it works for nested pattern masks

                if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;

                for (var bi = startBlockIndex; bi < this._blocks.length; ++bi) {
                    var d = this._blocks[bi]._appendEager();

                    if (!d.inserted) break;
                    details.aggregate(d);
                }

                return details;
            }
            /**
             @override
             */

        }, {
            key: "_appendCharRaw",
            value: function _appendCharRaw(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var blockIter = this._mapPosToBlock(this.value.length);

                var details = new ChangeDetails();
                if (!blockIter) return details;

                for (var bi = blockIter.index;; ++bi) {
                    var _flags$_beforeTailSta;

                    var _block = this._blocks[bi];
                    if (!_block) break;

                    var blockDetails = _block._appendChar(ch, Object.assign({}, flags, {
                        _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta._blocks[bi]
                    }));

                    var skip = blockDetails.skip;
                    details.aggregate(blockDetails);
                    if (skip || blockDetails.rawInserted) break; // go next char
                }

                return details;
            }
            /**
             @override
             */

        }, {
            key: "extractTail",
            value: function extractTail() {
                var _this2 = this;

                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                var chunkTail = new ChunksTailDetails();
                if (fromPos === toPos) return chunkTail;

                this._forEachBlocksInRange(fromPos, toPos, function (b, bi, bFromPos, bToPos) {
                    var blockChunk = b.extractTail(bFromPos, bToPos);
                    blockChunk.stop = _this2._findStopBefore(bi);
                    blockChunk.from = _this2._blockStartPos(bi);
                    if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
                    chunkTail.extend(blockChunk);
                });

                return chunkTail;
            }
            /**
             @override
             */

        }, {
            key: "extractInput",
            value: function extractInput() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                if (fromPos === toPos) return '';
                var input = '';

                this._forEachBlocksInRange(fromPos, toPos, function (b, _, fromPos, toPos) {
                    input += b.extractInput(fromPos, toPos, flags);
                });

                return input;
            }
        }, {
            key: "_findStopBefore",
            value: function _findStopBefore(blockIndex) {
                var stopBefore;

                for (var si = 0; si < this._stops.length; ++si) {
                    var stop = this._stops[si];
                    if (stop <= blockIndex) stopBefore = stop;else break;
                }

                return stopBefore;
            }
            /** Appends placeholder depending on laziness */

        }, {
            key: "_appendPlaceholder",
            value: function _appendPlaceholder(toBlockIndex) {
                var _this3 = this;

                var details = new ChangeDetails();
                if (this.lazy && toBlockIndex == null) return details;

                var startBlockIter = this._mapPosToBlock(this.value.length);

                if (!startBlockIter) return details;
                var startBlockIndex = startBlockIter.index;
                var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;

                this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function (b) {
                    if (!b.lazy || toBlockIndex != null) {
                        // $FlowFixMe `_blocks` may not be present
                        var args = b._blocks != null ? [b._blocks.length] : [];

                        var bDetails = b._appendPlaceholder.apply(b, args);

                        _this3._value += bDetails.inserted;
                        details.aggregate(bDetails);
                    }
                });

                return details;
            }
            /** Finds block in pos */

        }, {
            key: "_mapPosToBlock",
            value: function _mapPosToBlock(pos) {
                var accVal = '';

                for (var bi = 0; bi < this._blocks.length; ++bi) {
                    var _block2 = this._blocks[bi];
                    var blockStartPos = accVal.length;
                    accVal += _block2.value;

                    if (pos <= accVal.length) {
                        return {
                            index: bi,
                            offset: pos - blockStartPos
                        };
                    }
                }
            }
            /** */

        }, {
            key: "_blockStartPos",
            value: function _blockStartPos(blockIndex) {
                return this._blocks.slice(0, blockIndex).reduce(function (pos, b) {
                    return pos += b.value.length;
                }, 0);
            }
            /** */

        }, {
            key: "_forEachBlocksInRange",
            value: function _forEachBlocksInRange(fromPos) {
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                var fn = arguments.length > 2 ? arguments[2] : undefined;

                var fromBlockIter = this._mapPosToBlock(fromPos);

                if (fromBlockIter) {
                    var toBlockIter = this._mapPosToBlock(toPos); // process first block


                    var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
                    var fromBlockStartPos = fromBlockIter.offset;
                    var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
                    fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);

                    if (toBlockIter && !isSameBlock) {
                        // process intermediate blocks
                        for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
                            fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
                        } // process last block


                        fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
                    }
                }
            }
            /**
             @override
             */

        }, {
            key: "remove",
            value: function remove() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

                var removeDetails = _get(_getPrototypeOf(MaskedPattern.prototype), "remove", this).call(this, fromPos, toPos);

                this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
                    removeDetails.aggregate(b.remove(bFromPos, bToPos));
                });

                return removeDetails;
            }
            /**
             @override
             */

        }, {
            key: "nearestInputPos",
            value: function nearestInputPos(cursorPos) {
                var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
                if (!this._blocks.length) return 0;
                var cursor = new PatternCursor(this, cursorPos);

                if (direction === DIRECTION.NONE) {
                    // -------------------------------------------------
                    // NONE should only go out from fixed to the right!
                    // -------------------------------------------------
                    if (cursor.pushRightBeforeInput()) return cursor.pos;
                    cursor.popState();
                    if (cursor.pushLeftBeforeInput()) return cursor.pos;
                    return this.value.length;
                } // FORCE is only about a|* otherwise is 0


                if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
                    // try to break fast when *|a
                    if (direction === DIRECTION.LEFT) {
                        cursor.pushRightBeforeFilled();
                        if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                        cursor.popState();
                    } // forward flow


                    cursor.pushLeftBeforeInput();
                    cursor.pushLeftBeforeRequired();
                    cursor.pushLeftBeforeFilled(); // backward flow

                    if (direction === DIRECTION.LEFT) {
                        cursor.pushRightBeforeInput();
                        cursor.pushRightBeforeRequired();
                        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                        cursor.popState();
                        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                        cursor.popState();
                    }

                    if (cursor.ok) return cursor.pos;
                    if (direction === DIRECTION.FORCE_LEFT) return 0;
                    cursor.popState();
                    if (cursor.ok) return cursor.pos;
                    cursor.popState();
                    if (cursor.ok) return cursor.pos; // cursor.popState();
                    // if (
                    //   cursor.pushRightBeforeInput() &&
                    //   // TODO HACK for lazy if has aligned left inside fixed and has came to the start - use start position
                    //   (!this.lazy || this.extractInput())
                    // ) return cursor.pos;

                    return 0;
                }

                if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
                    // forward flow
                    cursor.pushRightBeforeInput();
                    cursor.pushRightBeforeRequired();
                    if (cursor.pushRightBeforeFilled()) return cursor.pos;
                    if (direction === DIRECTION.FORCE_RIGHT) return this.value.length; // backward flow

                    cursor.popState();
                    if (cursor.ok) return cursor.pos;
                    cursor.popState();
                    if (cursor.ok) return cursor.pos;
                    return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
                }

                return cursorPos;
            }
            /** Get block by name */

        }, {
            key: "maskedBlock",
            value: function maskedBlock(name) {
                return this.maskedBlocks(name)[0];
            }
            /** Get all blocks by name */

        }, {
            key: "maskedBlocks",
            value: function maskedBlocks(name) {
                var _this4 = this;

                var indices = this._maskedBlocks[name];
                if (!indices) return [];
                return indices.map(function (gi) {
                    return _this4._blocks[gi];
                });
            }
        }]);

        return MaskedPattern;
    }(Masked);
    MaskedPattern.DEFAULTS = {
        lazy: true,
        placeholderChar: '_'
    };
    MaskedPattern.STOP_CHAR = '`';
    MaskedPattern.ESCAPE_CHAR = '\\';
    MaskedPattern.InputDefinition = PatternInputDefinition;
    MaskedPattern.FixedDefinition = PatternFixedDefinition;
    IMask.MaskedPattern = MaskedPattern;

    /** Pattern which accepts ranges */

    var MaskedRange = /*#__PURE__*/function (_MaskedPattern) {
        _inherits(MaskedRange, _MaskedPattern);

        var _super = _createSuper(MaskedRange);

        function MaskedRange() {
            _classCallCheck(this, MaskedRange);

            return _super.apply(this, arguments);
        }

        _createClass(MaskedRange, [{
            key: "_matchFrom",
            get:
            /**
             Optionally sets max length of pattern.
             Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
             */

            /** Min bound */

            /** Max bound */

                /** */
                function get() {
                    return this.maxLength - String(this.from).length;
                }
            /**
             @override
             */

        }, {
            key: "_update",
            value: function _update(opts) {
                // TODO type
                opts = Object.assign({
                    to: this.to || 0,
                    from: this.from || 0,
                    maxLength: this.maxLength || 0
                }, opts);
                var maxLength = String(opts.to).length;
                if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
                opts.maxLength = maxLength;
                var fromStr = String(opts.from).padStart(maxLength, '0');
                var toStr = String(opts.to).padStart(maxLength, '0');
                var sameCharsCount = 0;

                while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
                    ++sameCharsCount;
                }

                opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(maxLength - sameCharsCount);

                _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, opts);
            }
            /**
             @override
             */

        }, {
            key: "isComplete",
            get: function get() {
                return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
            }
        }, {
            key: "boundaries",
            value: function boundaries(str) {
                var minstr = '';
                var maxstr = '';

                var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
                    _ref2 = _slicedToArray(_ref, 3),
                    placeholder = _ref2[1],
                    num = _ref2[2];

                if (num) {
                    minstr = '0'.repeat(placeholder.length) + num;
                    maxstr = '9'.repeat(placeholder.length) + num;
                }

                minstr = minstr.padEnd(this.maxLength, '0');
                maxstr = maxstr.padEnd(this.maxLength, '9');
                return [minstr, maxstr];
            } // TODO str is a single char everytime

            /**
             @override
             */

        }, {
            key: "doPrepare",
            value: function doPrepare(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var details;

                var _normalizePrepare = normalizePrepare(_get(_getPrototypeOf(MaskedRange.prototype), "doPrepare", this).call(this, ch.replace(/\D/g, ''), flags));

                var _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2);

                ch = _normalizePrepare2[0];
                details = _normalizePrepare2[1];
                if (!this.autofix || !ch) return ch;
                var fromStr = String(this.from).padStart(this.maxLength, '0');
                var toStr = String(this.to).padStart(this.maxLength, '0');
                var nextVal = this.value + ch;
                if (nextVal.length > this.maxLength) return '';

                var _this$boundaries = this.boundaries(nextVal),
                    _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
                    minstr = _this$boundaries2[0],
                    maxstr = _this$boundaries2[1];

                if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];

                if (Number(minstr) > this.to) {
                    if (this.autofix === 'pad' && nextVal.length < this.maxLength) {
                        return ['', details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
                    }

                    return toStr[nextVal.length - 1];
                }

                return ch;
            }
            /**
             @override
             */

        }, {
            key: "doValidate",
            value: function doValidate() {
                var _get2;

                var str = this.value;
                var firstNonZero = str.search(/[^0]/);
                if (firstNonZero === -1 && str.length <= this._matchFrom) return true;

                var _this$boundaries3 = this.boundaries(str),
                    _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
                    minstr = _this$boundaries4[0],
                    maxstr = _this$boundaries4[1];

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
            }
        }]);

        return MaskedRange;
    }(MaskedPattern);
    IMask.MaskedRange = MaskedRange;

    /** Date mask */

    var MaskedDate = /*#__PURE__*/function (_MaskedPattern) {
        _inherits(MaskedDate, _MaskedPattern);

        var _super = _createSuper(MaskedDate);

        /** Pattern mask for date according to {@link MaskedDate#format} */

        /** Start date */

        /** End date */

        /** */

        /**
         @param {Object} opts
         */
        function MaskedDate(opts) {
            _classCallCheck(this, MaskedDate);

            return _super.call(this, Object.assign({}, MaskedDate.DEFAULTS, opts));
        }
        /**
         @override
         */


        _createClass(MaskedDate, [{
            key: "_update",
            value: function _update(opts) {
                if (opts.mask === Date) delete opts.mask;
                if (opts.pattern) opts.mask = opts.pattern;
                var blocks = opts.blocks;
                opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS()); // adjust year block

                if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
                if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();

                if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
                    opts.blocks.m.from = opts.min.getMonth() + 1;
                    opts.blocks.m.to = opts.max.getMonth() + 1;

                    if (opts.blocks.m.from === opts.blocks.m.to) {
                        opts.blocks.d.from = opts.min.getDate();
                        opts.blocks.d.to = opts.max.getDate();
                    }
                }

                Object.assign(opts.blocks, this.blocks, blocks); // add autofix

                Object.keys(opts.blocks).forEach(function (bk) {
                    var b = opts.blocks[bk];
                    if (!('autofix' in b) && 'autofix' in opts) b.autofix = opts.autofix;
                });

                _get(_getPrototypeOf(MaskedDate.prototype), "_update", this).call(this, opts);
            }
            /**
             @override
             */

        }, {
            key: "doValidate",
            value: function doValidate() {
                var _get2;

                var date = this.date;

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return (_get2 = _get(_getPrototypeOf(MaskedDate.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
            }
            /** Checks if date is exists */

        }, {
            key: "isDateExist",
            value: function isDateExist(str) {
                return this.format(this.parse(str, this), this).indexOf(str) >= 0;
            }
            /** Parsed Date */

        }, {
            key: "date",
            get: function get() {
                return this.typedValue;
            },
            set: function set(date) {
                this.typedValue = date;
            }
            /**
             @override
             */

        }, {
            key: "typedValue",
            get: function get() {
                return this.isComplete ? _get(_getPrototypeOf(MaskedDate.prototype), "typedValue", this) : null;
            },
            set: function set(value) {
                _set(_getPrototypeOf(MaskedDate.prototype), "typedValue", value, this, true);
            }
            /**
             @override
             */

        }, {
            key: "maskEquals",
            value: function maskEquals(mask) {
                return mask === Date || _get(_getPrototypeOf(MaskedDate.prototype), "maskEquals", this).call(this, mask);
            }
        }]);

        return MaskedDate;
    }(MaskedPattern);
    MaskedDate.DEFAULTS = {
        pattern: 'd{.}`m{.}`Y',
        format: function format(date) {
            if (!date) return '';
            var day = String(date.getDate()).padStart(2, '0');
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var year = date.getFullYear();
            return [day, month, year].join('.');
        },
        parse: function parse(str) {
            var _str$split = str.split('.'),
                _str$split2 = _slicedToArray(_str$split, 3),
                day = _str$split2[0],
                month = _str$split2[1],
                year = _str$split2[2];

            return new Date(year, month - 1, day);
        }
    };

    MaskedDate.GET_DEFAULT_BLOCKS = function () {
        return {
            d: {
                mask: MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2
            },
            m: {
                mask: MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2
            },
            Y: {
                mask: MaskedRange,
                from: 1900,
                to: 9999
            }
        };
    };

    IMask.MaskedDate = MaskedDate;

    /**
     Generic element API to use with mask
     @interface
     */
    var MaskElement = /*#__PURE__*/function () {
        function MaskElement() {
            _classCallCheck(this, MaskElement);
        }

        _createClass(MaskElement, [{
            key: "selectionStart",
            get:
            /** */

            /** */

            /** */

                /** Safely returns selection start */
                function get() {
                    var start;

                    try {
                        start = this._unsafeSelectionStart;
                    } catch (e) {}

                    return start != null ? start : this.value.length;
                }
            /** Safely returns selection end */

        }, {
            key: "selectionEnd",
            get: function get() {
                var end;

                try {
                    end = this._unsafeSelectionEnd;
                } catch (e) {}

                return end != null ? end : this.value.length;
            }
            /** Safely sets element selection */

        }, {
            key: "select",
            value: function select(start, end) {
                if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;

                try {
                    this._unsafeSelect(start, end);
                } catch (e) {}
            }
            /** Should be overriden in subclasses */

        }, {
            key: "_unsafeSelect",
            value: function _unsafeSelect(start, end) {}
            /** Should be overriden in subclasses */

        }, {
            key: "isActive",
            get: function get() {
                return false;
            }
            /** Should be overriden in subclasses */

        }, {
            key: "bindEvents",
            value: function bindEvents(handlers) {}
            /** Should be overriden in subclasses */

        }, {
            key: "unbindEvents",
            value: function unbindEvents() {}
        }]);

        return MaskElement;
    }();
    IMask.MaskElement = MaskElement;

    /** Bridge between HTMLElement and {@link Masked} */

    var HTMLMaskElement = /*#__PURE__*/function (_MaskElement) {
        _inherits(HTMLMaskElement, _MaskElement);

        var _super = _createSuper(HTMLMaskElement);

        /** Mapping between HTMLElement events and mask internal events */

        /** HTMLElement to use mask on */

        /**
         @param {HTMLInputElement|HTMLTextAreaElement} input
         */
        function HTMLMaskElement(input) {
            var _this;

            _classCallCheck(this, HTMLMaskElement);

            _this = _super.call(this);
            _this.input = input;
            _this._handlers = {};
            return _this;
        }
        /** */
        // $FlowFixMe https://github.com/facebook/flow/issues/2839


        _createClass(HTMLMaskElement, [{
            key: "rootElement",
            get: function get() {
                var _this$input$getRootNo, _this$input$getRootNo2, _this$input;

                return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
            }
            /**
             Is element in focus
             @readonly
             */

        }, {
            key: "isActive",
            get: function get() {
                //$FlowFixMe
                return this.input === this.rootElement.activeElement;
            }
            /**
             Returns HTMLElement selection start
             @override
             */

        }, {
            key: "_unsafeSelectionStart",
            get: function get() {
                return this.input.selectionStart;
            }
            /**
             Returns HTMLElement selection end
             @override
             */

        }, {
            key: "_unsafeSelectionEnd",
            get: function get() {
                return this.input.selectionEnd;
            }
            /**
             Sets HTMLElement selection
             @override
             */

        }, {
            key: "_unsafeSelect",
            value: function _unsafeSelect(start, end) {
                this.input.setSelectionRange(start, end);
            }
            /**
             HTMLElement value
             @override
             */

        }, {
            key: "value",
            get: function get() {
                return this.input.value;
            },
            set: function set(value) {
                this.input.value = value;
            }
            /**
             Binds HTMLElement events to mask internal events
             @override
             */

        }, {
            key: "bindEvents",
            value: function bindEvents(handlers) {
                var _this2 = this;

                Object.keys(handlers).forEach(function (event) {
                    return _this2._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]);
                });
            }
            /**
             Unbinds HTMLElement events to mask internal events
             @override
             */

        }, {
            key: "unbindEvents",
            value: function unbindEvents() {
                var _this3 = this;

                Object.keys(this._handlers).forEach(function (event) {
                    return _this3._toggleEventHandler(event);
                });
            }
            /** */

        }, {
            key: "_toggleEventHandler",
            value: function _toggleEventHandler(event, handler) {
                if (this._handlers[event]) {
                    this.input.removeEventListener(event, this._handlers[event]);
                    delete this._handlers[event];
                }

                if (handler) {
                    this.input.addEventListener(event, handler);
                    this._handlers[event] = handler;
                }
            }
        }]);

        return HTMLMaskElement;
    }(MaskElement);
    HTMLMaskElement.EVENTS_MAP = {
        selectionChange: 'keydown',
        input: 'input',
        drop: 'drop',
        click: 'click',
        focus: 'focus',
        commit: 'blur'
    };
    IMask.HTMLMaskElement = HTMLMaskElement;

    var HTMLContenteditableMaskElement = /*#__PURE__*/function (_HTMLMaskElement) {
        _inherits(HTMLContenteditableMaskElement, _HTMLMaskElement);

        var _super = _createSuper(HTMLContenteditableMaskElement);

        function HTMLContenteditableMaskElement() {
            _classCallCheck(this, HTMLContenteditableMaskElement);

            return _super.apply(this, arguments);
        }

        _createClass(HTMLContenteditableMaskElement, [{
            key: "_unsafeSelectionStart",
            get:
                /**
                 Returns HTMLElement selection start
                 @override
                 */
                function get() {
                    var root = this.rootElement;
                    var selection = root.getSelection && root.getSelection();
                    var anchorOffset = selection && selection.anchorOffset;
                    var focusOffset = selection && selection.focusOffset;

                    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
                        return anchorOffset;
                    }

                    return focusOffset;
                }
            /**
             Returns HTMLElement selection end
             @override
             */

        }, {
            key: "_unsafeSelectionEnd",
            get: function get() {
                var root = this.rootElement;
                var selection = root.getSelection && root.getSelection();
                var anchorOffset = selection && selection.anchorOffset;
                var focusOffset = selection && selection.focusOffset;

                if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
                    return anchorOffset;
                }

                return focusOffset;
            }
            /**
             Sets HTMLElement selection
             @override
             */

        }, {
            key: "_unsafeSelect",
            value: function _unsafeSelect(start, end) {
                if (!this.rootElement.createRange) return;
                var range = this.rootElement.createRange();
                range.setStart(this.input.firstChild || this.input, start);
                range.setEnd(this.input.lastChild || this.input, end);
                var root = this.rootElement;
                var selection = root.getSelection && root.getSelection();

                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
            /**
             HTMLElement value
             @override
             */

        }, {
            key: "value",
            get: function get() {
                // $FlowFixMe
                return this.input.textContent;
            },
            set: function set(value) {
                this.input.textContent = value;
            }
        }]);

        return HTMLContenteditableMaskElement;
    }(HTMLMaskElement);
    IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

    var _excluded$1 = ["mask"];
    /** Listens to element events and controls changes between element and {@link Masked} */

    var InputMask = /*#__PURE__*/function () {
        /**
         View element
         @readonly
         */

        /**
         Internal {@link Masked} model
         @readonly
         */

        /**
         @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
         @param {Object} opts
         */
        function InputMask(el, opts) {
            _classCallCheck(this, InputMask);

            this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
            this.masked = createMask(opts);
            this._listeners = {};
            this._value = '';
            this._unmaskedValue = '';
            this._saveSelection = this._saveSelection.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onChange = this._onChange.bind(this);
            this._onDrop = this._onDrop.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onClick = this._onClick.bind(this);
            this.alignCursor = this.alignCursor.bind(this);
            this.alignCursorFriendly = this.alignCursorFriendly.bind(this);

            this._bindEvents(); // refresh


            this.updateValue();

            this._onChange();
        }
        /** Read or update mask */


        _createClass(InputMask, [{
            key: "mask",
            get: function get() {
                return this.masked.mask;
            },
            set: function set(mask) {
                if (this.maskEquals(mask)) return; // $FlowFixMe No ideas ... after update

                if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
                    this.masked.updateOptions({
                        mask: mask
                    });
                    return;
                }

                var masked = createMask({
                    mask: mask
                });
                masked.unmaskedValue = this.masked.unmaskedValue;
                this.masked = masked;
            }
            /** Raw value */

        }, {
            key: "maskEquals",
            value: function maskEquals(mask) {
                var _this$masked;

                return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
            }
        }, {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(str) {
                this.masked.value = str;
                this.updateControl();
                this.alignCursor();
            }
            /** Unmasked value */

        }, {
            key: "unmaskedValue",
            get: function get() {
                return this._unmaskedValue;
            },
            set: function set(str) {
                this.masked.unmaskedValue = str;
                this.updateControl();
                this.alignCursor();
            }
            /** Typed unmasked value */

        }, {
            key: "typedValue",
            get: function get() {
                return this.masked.typedValue;
            },
            set: function set(val) {
                this.masked.typedValue = val;
                this.updateControl();
                this.alignCursor();
            }
            /**
             Starts listening to element events
             @protected
             */

        }, {
            key: "_bindEvents",
            value: function _bindEvents() {
                this.el.bindEvents({
                    selectionChange: this._saveSelection,
                    input: this._onInput,
                    drop: this._onDrop,
                    click: this._onClick,
                    focus: this._onFocus,
                    commit: this._onChange
                });
            }
            /**
             Stops listening to element events
             @protected
             */

        }, {
            key: "_unbindEvents",
            value: function _unbindEvents() {
                if (this.el) this.el.unbindEvents();
            }
            /**
             Fires custom event
             @protected
             */

        }, {
            key: "_fireEvent",
            value: function _fireEvent(ev) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                var listeners = this._listeners[ev];
                if (!listeners) return;
                listeners.forEach(function (l) {
                    return l.apply(void 0, args);
                });
            }
            /**
             Current selection start
             @readonly
             */

        }, {
            key: "selectionStart",
            get: function get() {
                return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
            }
            /** Current cursor position */

        }, {
            key: "cursorPos",
            get: function get() {
                return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
            },
            set: function set(pos) {
                if (!this.el || !this.el.isActive) return;
                this.el.select(pos, pos);

                this._saveSelection();
            }
            /**
             Stores current selection
             @protected
             */

        }, {
            key: "_saveSelection",
            value: function
                /* ev */
                _saveSelection() {
                if (this.value !== this.el.value) {
                    console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
                }

                this._selection = {
                    start: this.selectionStart,
                    end: this.cursorPos
                };
            }
            /** Syncronizes model value from view */

        }, {
            key: "updateValue",
            value: function updateValue() {
                this.masked.value = this.el.value;
                this._value = this.masked.value;
            }
            /** Syncronizes view from model value, fires change events */

        }, {
            key: "updateControl",
            value: function updateControl() {
                var newUnmaskedValue = this.masked.unmaskedValue;
                var newValue = this.masked.value;
                var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
                this._unmaskedValue = newUnmaskedValue;
                this._value = newValue;
                if (this.el.value !== newValue) this.el.value = newValue;
                if (isChanged) this._fireChangeEvents();
            }
            /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */

        }, {
            key: "updateOptions",
            value: function updateOptions(opts) {
                var mask = opts.mask,
                    restOpts = _objectWithoutProperties(opts, _excluded$1);

                var updateMask = !this.maskEquals(mask);
                var updateOpts = !objectIncludes(this.masked, restOpts);
                if (updateMask) this.mask = mask;
                if (updateOpts) this.masked.updateOptions(restOpts);
                if (updateMask || updateOpts) this.updateControl();
            }
            /** Updates cursor */

        }, {
            key: "updateCursor",
            value: function updateCursor(cursorPos) {
                if (cursorPos == null) return;
                this.cursorPos = cursorPos; // also queue change cursor for mobile browsers

                this._delayUpdateCursor(cursorPos);
            }
            /**
             Delays cursor update to support mobile browsers
             @private
             */

        }, {
            key: "_delayUpdateCursor",
            value: function _delayUpdateCursor(cursorPos) {
                var _this = this;

                this._abortUpdateCursor();

                this._changingCursorPos = cursorPos;
                this._cursorChanging = setTimeout(function () {
                    if (!_this.el) return; // if was destroyed

                    _this.cursorPos = _this._changingCursorPos;

                    _this._abortUpdateCursor();
                }, 10);
            }
            /**
             Fires custom events
             @protected
             */

        }, {
            key: "_fireChangeEvents",
            value: function _fireChangeEvents() {
                this._fireEvent('accept', this._inputEvent);

                if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
            }
            /**
             Aborts delayed cursor update
             @private
             */

        }, {
            key: "_abortUpdateCursor",
            value: function _abortUpdateCursor() {
                if (this._cursorChanging) {
                    clearTimeout(this._cursorChanging);
                    delete this._cursorChanging;
                }
            }
            /** Aligns cursor to nearest available position */

        }, {
            key: "alignCursor",
            value: function alignCursor() {
                this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
            }
            /** Aligns cursor only if selection is empty */

        }, {
            key: "alignCursorFriendly",
            value: function alignCursorFriendly() {
                if (this.selectionStart !== this.cursorPos) return; // skip if range is selected

                this.alignCursor();
            }
            /** Adds listener on custom event */

        }, {
            key: "on",
            value: function on(ev, handler) {
                if (!this._listeners[ev]) this._listeners[ev] = [];

                this._listeners[ev].push(handler);

                return this;
            }
            /** Removes custom event listener */

        }, {
            key: "off",
            value: function off(ev, handler) {
                if (!this._listeners[ev]) return this;

                if (!handler) {
                    delete this._listeners[ev];
                    return this;
                }

                var hIndex = this._listeners[ev].indexOf(handler);

                if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
                return this;
            }
            /** Handles view input event */

        }, {
            key: "_onInput",
            value: function _onInput(e) {
                this._inputEvent = e;

                this._abortUpdateCursor(); // fix strange IE behavior


                if (!this._selection) return this.updateValue();
                var details = new ActionDetails( // new state
                    this.el.value, this.cursorPos, // old state
                    this.value, this._selection);
                var oldRawValue = this.masked.rawInputValue;
                var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection).offset; // force align in remove direction only if no input chars were removed
                // otherwise we still need to align with NONE (to get out from fixed symbols for instance)

                var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
                var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
                if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
                this.updateControl();
                this.updateCursor(cursorPos);
                delete this._inputEvent;
            }
            /** Handles view change event and commits model value */

        }, {
            key: "_onChange",
            value: function _onChange() {
                if (this.value !== this.el.value) {
                    this.updateValue();
                }

                this.masked.doCommit();
                this.updateControl();

                this._saveSelection();
            }
            /** Handles view drop event, prevents by default */

        }, {
            key: "_onDrop",
            value: function _onDrop(ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            /** Restore last selection on focus */

        }, {
            key: "_onFocus",
            value: function _onFocus(ev) {
                this.alignCursorFriendly();
            }
            /** Restore last selection on focus */

        }, {
            key: "_onClick",
            value: function _onClick(ev) {
                this.alignCursorFriendly();
            }
            /** Unbind view events and removes element reference */

        }, {
            key: "destroy",
            value: function destroy() {
                this._unbindEvents(); // $FlowFixMe why not do so?


                this._listeners.length = 0; // $FlowFixMe

                delete this.el;
            }
        }]);

        return InputMask;
    }();
    IMask.InputMask = InputMask;

    /** Pattern which validates enum values */

    var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
        _inherits(MaskedEnum, _MaskedPattern);

        var _super = _createSuper(MaskedEnum);

        function MaskedEnum() {
            _classCallCheck(this, MaskedEnum);

            return _super.apply(this, arguments);
        }

        _createClass(MaskedEnum, [{
            key: "_update",
            value:
                /**
                 @override
                 @param {Object} opts
                 */
                function _update(opts) {
                    // TODO type
                    if (opts.enum) opts.mask = '*'.repeat(opts.enum[0].length);

                    _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, opts);
                }
            /**
             @override
             */

        }, {
            key: "doValidate",
            value: function doValidate() {
                var _this = this,
                    _get2;

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return this.enum.some(function (e) {
                    return e.indexOf(_this.unmaskedValue) >= 0;
                }) && (_get2 = _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
            }
        }]);

        return MaskedEnum;
    }(MaskedPattern);
    IMask.MaskedEnum = MaskedEnum;

    /**
     Number mask
     @param {Object} opts
     @param {string} opts.radix - Single char
     @param {string} opts.thousandsSeparator - Single char
     @param {Array<string>} opts.mapToRadix - Array of single chars
     @param {number} opts.min
     @param {number} opts.max
     @param {number} opts.scale - Digits after point
     @param {boolean} opts.signed - Allow negative
     @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
     @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
     */
    var MaskedNumber = /*#__PURE__*/function (_Masked) {
        _inherits(MaskedNumber, _Masked);

        var _super = _createSuper(MaskedNumber);

        /** Single char */

        /** Single char */

        /** Array of single chars */

        /** */

        /** */

        /** Digits after point */

        /** */

        /** Flag to remove leading and trailing zeros in the end of editing */

        /** Flag to pad trailing zeros after point in the end of editing */
        function MaskedNumber(opts) {
            _classCallCheck(this, MaskedNumber);

            return _super.call(this, Object.assign({}, MaskedNumber.DEFAULTS, opts));
        }
        /**
         @override
         */


        _createClass(MaskedNumber, [{
            key: "_update",
            value: function _update(opts) {
                _get(_getPrototypeOf(MaskedNumber.prototype), "_update", this).call(this, opts);

                this._updateRegExps();
            }
            /** */

        }, {
            key: "_updateRegExps",
            value: function _updateRegExps() {
                // use different regexp to process user input (more strict, input suffix) and tail shifting
                var start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
                var midInput = '(0|([1-9]+\\d*))?';
                var mid = '\\d*';
                var end = (this.scale ? '(' + escapeRegExp(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
                this._numberRegExpInput = new RegExp(start + midInput + end);
                this._numberRegExp = new RegExp(start + mid + end);
                this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(escapeRegExp).join('') + ']', 'g');
                this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
            }
            /** */

        }, {
            key: "_removeThousandsSeparators",
            value: function _removeThousandsSeparators(value) {
                return value.replace(this._thousandsSeparatorRegExp, '');
            }
            /** */

        }, {
            key: "_insertThousandsSeparators",
            value: function _insertThousandsSeparators(value) {
                // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
                var parts = value.split(this.radix);
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
                return parts.join(this.radix);
            }
            /**
             @override
             */

        }, {
            key: "doPrepare",
            value: function doPrepare(ch) {
                var _get2;

                ch = ch.replace(this._mapToRadixRegExp, this.radix);

                var noSepCh = this._removeThousandsSeparators(ch);

                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                var _normalizePrepare = normalizePrepare((_get2 = _get(_getPrototypeOf(MaskedNumber.prototype), "doPrepare", this)).call.apply(_get2, [this, noSepCh].concat(args))),
                    _normalizePrepare2 = _slicedToArray(_normalizePrepare, 2),
                    prepCh = _normalizePrepare2[0],
                    details = _normalizePrepare2[1];

                if (ch && !noSepCh) details.skip = true;
                return [prepCh, details];
            }
            /** */

        }, {
            key: "_separatorsCount",
            value: function _separatorsCount(to) {
                var extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var count = 0;

                for (var pos = 0; pos < to; ++pos) {
                    if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
                        ++count;
                        if (extendOnSeparators) to += this.thousandsSeparator.length;
                    }
                }

                return count;
            }
            /** */

        }, {
            key: "_separatorsCountFromSlice",
            value: function _separatorsCountFromSlice() {
                var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
                return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
            }
            /**
             @override
             */

        }, {
            key: "extractInput",
            value: function extractInput() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
                var flags = arguments.length > 2 ? arguments[2] : undefined;

                var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);

                var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);

                fromPos = _this$_adjustRangeWit2[0];
                toPos = _this$_adjustRangeWit2[1];
                return this._removeThousandsSeparators(_get(_getPrototypeOf(MaskedNumber.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
            }
            /**
             @override
             */

        }, {
            key: "_appendCharRaw",
            value: function _appendCharRaw(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.thousandsSeparator) return _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
                var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

                var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);

                this._value = this._removeThousandsSeparators(this.value);

                var appendDetails = _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);

                this._value = this._insertThousandsSeparators(this._value);
                var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

                var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);

                appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
                appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
                return appendDetails;
            }
            /** */

        }, {
            key: "_findSeparatorAround",
            value: function _findSeparatorAround(pos) {
                if (this.thousandsSeparator) {
                    var searchFrom = pos - this.thousandsSeparator.length + 1;
                    var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
                    if (separatorPos <= pos) return separatorPos;
                }

                return -1;
            }
        }, {
            key: "_adjustRangeWithSeparators",
            value: function _adjustRangeWithSeparators(from, to) {
                var separatorAroundFromPos = this._findSeparatorAround(from);

                if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;

                var separatorAroundToPos = this._findSeparatorAround(to);

                if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
                return [from, to];
            }
            /**
             @override
             */

        }, {
            key: "remove",
            value: function remove() {
                var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

                var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);

                var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);

                fromPos = _this$_adjustRangeWit4[0];
                toPos = _this$_adjustRangeWit4[1];
                var valueBeforePos = this.value.slice(0, fromPos);
                var valueAfterPos = this.value.slice(toPos);

                var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);

                this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));

                var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);

                return new ChangeDetails({
                    tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
                });
            }
            /**
             @override
             */

        }, {
            key: "nearestInputPos",
            value: function nearestInputPos(cursorPos, direction) {
                if (!this.thousandsSeparator) return cursorPos;

                switch (direction) {
                    case DIRECTION.NONE:
                    case DIRECTION.LEFT:
                    case DIRECTION.FORCE_LEFT:
                    {
                        var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);

                        if (separatorAtLeftPos >= 0) {
                            var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;

                            if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
                                return separatorAtLeftPos;
                            }
                        }

                        break;
                    }

                    case DIRECTION.RIGHT:
                    case DIRECTION.FORCE_RIGHT:
                    {
                        var separatorAtRightPos = this._findSeparatorAround(cursorPos);

                        if (separatorAtRightPos >= 0) {
                            return separatorAtRightPos + this.thousandsSeparator.length;
                        }
                    }
                }

                return cursorPos;
            }
            /**
             @override
             */

        }, {
            key: "doValidate",
            value: function doValidate(flags) {
                var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp; // validate as string

                var valid = regexp.test(this._removeThousandsSeparators(this.value));

                if (valid) {
                    // validate as number
                    var number = this.number;
                    valid = valid && !isNaN(number) && ( // check min bound for negative values
                        this.min == null || this.min >= 0 || this.min <= this.number) && ( // check max bound for positive values
                        this.max == null || this.max <= 0 || this.number <= this.max);
                }

                return valid && _get(_getPrototypeOf(MaskedNumber.prototype), "doValidate", this).call(this, flags);
            }
            /**
             @override
             */

        }, {
            key: "doCommit",
            value: function doCommit() {
                if (this.value) {
                    var number = this.number;
                    var validnum = number; // check bounds

                    if (this.min != null) validnum = Math.max(validnum, this.min);
                    if (this.max != null) validnum = Math.min(validnum, this.max);
                    if (validnum !== number) this.unmaskedValue = String(validnum);
                    var formatted = this.value;
                    if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
                    if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
                    this._value = formatted;
                }

                _get(_getPrototypeOf(MaskedNumber.prototype), "doCommit", this).call(this);
            }
            /** */

        }, {
            key: "_normalizeZeros",
            value: function _normalizeZeros(value) {
                var parts = this._removeThousandsSeparators(value).split(this.radix); // remove leading zeros


                parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function (match, sign, zeros, num) {
                    return sign + num;
                }); // add leading zero

                if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';

                if (parts.length > 1) {
                    parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros

                    if (!parts[1].length) parts.length = 1; // remove fractional
                }

                return this._insertThousandsSeparators(parts.join(this.radix));
            }
            /** */

        }, {
            key: "_padFractionalZeros",
            value: function _padFractionalZeros(value) {
                if (!value) return value;
                var parts = value.split(this.radix);
                if (parts.length < 2) parts.push('');
                parts[1] = parts[1].padEnd(this.scale, '0');
                return parts.join(this.radix);
            }
            /**
             @override
             */

        }, {
            key: "unmaskedValue",
            get: function get() {
                return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, '.');
            },
            set: function set(unmaskedValue) {
                _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", unmaskedValue.replace('.', this.radix), this, true);
            }
            /**
             @override
             */

        }, {
            key: "typedValue",
            get: function get() {
                return Number(this.unmaskedValue);
            },
            set: function set(n) {
                _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", String(n), this, true);
            }
            /** Parsed Number */

        }, {
            key: "number",
            get: function get() {
                return this.typedValue;
            },
            set: function set(number) {
                this.typedValue = number;
            }
            /**
             Is negative allowed
             @readonly
             */

        }, {
            key: "allowNegative",
            get: function get() {
                return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
            }
        }]);

        return MaskedNumber;
    }(Masked);
    MaskedNumber.DEFAULTS = {
        radix: ',',
        thousandsSeparator: '',
        mapToRadix: ['.'],
        scale: 2,
        signed: false,
        normalizeZeros: true,
        padFractionalZeros: false
    };
    IMask.MaskedNumber = MaskedNumber;

    /** Masking by custom Function */

    var MaskedFunction = /*#__PURE__*/function (_Masked) {
        _inherits(MaskedFunction, _Masked);

        var _super = _createSuper(MaskedFunction);

        function MaskedFunction() {
            _classCallCheck(this, MaskedFunction);

            return _super.apply(this, arguments);
        }

        _createClass(MaskedFunction, [{
            key: "_update",
            value:
                /**
                 @override
                 @param {Object} opts
                 */
                function _update(opts) {
                    if (opts.mask) opts.validate = opts.mask;

                    _get(_getPrototypeOf(MaskedFunction.prototype), "_update", this).call(this, opts);
                }
        }]);

        return MaskedFunction;
    }(Masked);
    IMask.MaskedFunction = MaskedFunction;

    var _excluded = ["compiledMasks", "currentMaskRef", "currentMask"];

    /** Dynamic mask for choosing apropriate mask in run-time */
    var MaskedDynamic = /*#__PURE__*/function (_Masked) {
        _inherits(MaskedDynamic, _Masked);

        var _super = _createSuper(MaskedDynamic);

        /** Currently chosen mask */

        /** Compliled {@link Masked} options */

        /** Chooses {@link Masked} depending on input value */

        /**
         @param {Object} opts
         */
        function MaskedDynamic(opts) {
            var _this;

            _classCallCheck(this, MaskedDynamic);

            _this = _super.call(this, Object.assign({}, MaskedDynamic.DEFAULTS, opts));
            _this.currentMask = null;
            return _this;
        }
        /**
         @override
         */


        _createClass(MaskedDynamic, [{
            key: "_update",
            value: function _update(opts) {
                _get(_getPrototypeOf(MaskedDynamic.prototype), "_update", this).call(this, opts);

                if ('mask' in opts) {
                    // mask could be totally dynamic with only `dispatch` option
                    this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function (m) {
                        return createMask(m);
                    }) : [];
                }
            }
            /**
             @override
             */

        }, {
            key: "_appendCharRaw",
            value: function _appendCharRaw(ch) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var details = this._applyDispatch(ch, flags);

                if (this.currentMask) {
                    details.aggregate(this.currentMask._appendChar(ch, flags));
                }

                return details;
            }
        }, {
            key: "_applyDispatch",
            value: function _applyDispatch() {
                var appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
                var inputValue = this.rawInputValue;
                var insertValue = flags.tail && flags._beforeTailState != null ? // $FlowFixMe - tired to fight with type system
                    flags._beforeTailState._rawInputValue : inputValue;
                var tailValue = inputValue.slice(insertValue.length);
                var prevMask = this.currentMask;
                var details = new ChangeDetails();
                var prevMaskState = prevMask && prevMask.state; // clone flags to prevent overwriting `_beforeTailState`

                this.currentMask = this.doDispatch(appended, Object.assign({}, flags)); // restore state after dispatch

                if (this.currentMask) {
                    if (this.currentMask !== prevMask) {
                        // if mask changed reapply input
                        this.currentMask.reset();

                        if (insertValue) {
                            // $FlowFixMe - it's ok, we don't change current mask above
                            var d = this.currentMask.append(insertValue, {
                                raw: true
                            });
                            details.tailShift = d.inserted.length - prevValueBeforeTail.length;
                        }

                        if (tailValue) {
                            // $FlowFixMe - it's ok, we don't change current mask above
                            details.tailShift += this.currentMask.append(tailValue, {
                                raw: true,
                                tail: true
                            }).tailShift;
                        }
                    } else {
                        // Dispatch can do something bad with state, so
                        // restore prev mask state
                        this.currentMask.state = prevMaskState;
                    }
                }

                return details;
            }
        }, {
            key: "_appendPlaceholder",
            value: function _appendPlaceholder() {
                var details = this._applyDispatch.apply(this, arguments);

                if (this.currentMask) {
                    details.aggregate(this.currentMask._appendPlaceholder());
                }

                return details;
            }
            /**
             @override
             */

        }, {
            key: "_appendEager",
            value: function _appendEager() {
                var details = this._applyDispatch.apply(this, arguments);

                if (this.currentMask) {
                    details.aggregate(this.currentMask._appendEager());
                }

                return details;
            }
            /**
             @override
             */

        }, {
            key: "doDispatch",
            value: function doDispatch(appended) {
                var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.dispatch(appended, this, flags);
            }
            /**
             @override
             */

        }, {
            key: "doValidate",
            value: function doValidate() {
                var _get2, _this$currentMask;

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return (_get2 = _get(_getPrototypeOf(MaskedDynamic.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.currentMask || (_this$currentMask = this.currentMask).doValidate.apply(_this$currentMask, args));
            }
            /**
             @override
             */

        }, {
            key: "reset",
            value: function reset() {
                var _this$currentMask2;

                (_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.reset();
                this.compiledMasks.forEach(function (m) {
                    return m.reset();
                });
            }
            /**
             @override
             */

        }, {
            key: "value",
            get: function get() {
                return this.currentMask ? this.currentMask.value : '';
            },
            set: function set(value) {
                _set(_getPrototypeOf(MaskedDynamic.prototype), "value", value, this, true);
            }
            /**
             @override
             */

        }, {
            key: "unmaskedValue",
            get: function get() {
                return this.currentMask ? this.currentMask.unmaskedValue : '';
            },
            set: function set(unmaskedValue) {
                _set(_getPrototypeOf(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
            }
            /**
             @override
             */

        }, {
            key: "typedValue",
            get: function get() {
                return this.currentMask ? this.currentMask.typedValue : '';
            } // probably typedValue should not be used with dynamic
            ,
            set: function set(value) {
                var unmaskedValue = String(value); // double check it

                if (this.currentMask) {
                    this.currentMask.typedValue = value;
                    unmaskedValue = this.currentMask.unmaskedValue;
                }

                this.unmaskedValue = unmaskedValue;
            }
            /**
             @override
             */

        }, {
            key: "isComplete",
            get: function get() {
                var _this$currentMask3;

                return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isComplete);
            }
            /**
             @override
             */

        }, {
            key: "isFilled",
            get: function get() {
                var _this$currentMask4;

                return Boolean((_this$currentMask4 = this.currentMask) === null || _this$currentMask4 === void 0 ? void 0 : _this$currentMask4.isFilled);
            }
            /**
             @override
             */

        }, {
            key: "remove",
            value: function remove() {
                var details = new ChangeDetails();

                if (this.currentMask) {
                    var _this$currentMask5;

                    details.aggregate((_this$currentMask5 = this.currentMask).remove.apply(_this$currentMask5, arguments)) // update with dispatch
                    .aggregate(this._applyDispatch());
                }

                return details;
            }
            /**
             @override
             */

        }, {
            key: "state",
            get: function get() {
                return Object.assign({}, _get(_getPrototypeOf(MaskedDynamic.prototype), "state", this), {
                    _rawInputValue: this.rawInputValue,
                    compiledMasks: this.compiledMasks.map(function (m) {
                        return m.state;
                    }),
                    currentMaskRef: this.currentMask,
                    currentMask: this.currentMask && this.currentMask.state
                });
            },
            set: function set(state) {
                var compiledMasks = state.compiledMasks,
                    currentMaskRef = state.currentMaskRef,
                    currentMask = state.currentMask,
                    maskedState = _objectWithoutProperties(state, _excluded);

                this.compiledMasks.forEach(function (m, mi) {
                    return m.state = compiledMasks[mi];
                });

                if (currentMaskRef != null) {
                    this.currentMask = currentMaskRef;
                    this.currentMask.state = currentMask;
                }

                _set(_getPrototypeOf(MaskedDynamic.prototype), "state", maskedState, this, true);
            }
            /**
             @override
             */

        }, {
            key: "extractInput",
            value: function extractInput() {
                var _this$currentMask6;

                return this.currentMask ? (_this$currentMask6 = this.currentMask).extractInput.apply(_this$currentMask6, arguments) : '';
            }
            /**
             @override
             */

        }, {
            key: "extractTail",
            value: function extractTail() {
                var _this$currentMask7, _get3;

                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                return this.currentMask ? (_this$currentMask7 = this.currentMask).extractTail.apply(_this$currentMask7, args) : (_get3 = _get(_getPrototypeOf(MaskedDynamic.prototype), "extractTail", this)).call.apply(_get3, [this].concat(args));
            }
            /**
             @override
             */

        }, {
            key: "doCommit",
            value: function doCommit() {
                if (this.currentMask) this.currentMask.doCommit();

                _get(_getPrototypeOf(MaskedDynamic.prototype), "doCommit", this).call(this);
            }
            /**
             @override
             */

        }, {
            key: "nearestInputPos",
            value: function nearestInputPos() {
                var _this$currentMask8, _get4;

                for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                }

                return this.currentMask ? (_this$currentMask8 = this.currentMask).nearestInputPos.apply(_this$currentMask8, args) : (_get4 = _get(_getPrototypeOf(MaskedDynamic.prototype), "nearestInputPos", this)).call.apply(_get4, [this].concat(args));
            }
        }, {
            key: "overwrite",
            get: function get() {
                return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf(MaskedDynamic.prototype), "overwrite", this);
            },
            set: function set(overwrite) {
                console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
            }
        }, {
            key: "eager",
            get: function get() {
                return this.currentMask ? this.currentMask.eager : _get(_getPrototypeOf(MaskedDynamic.prototype), "eager", this);
            },
            set: function set(eager) {
                console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
            }
            /**
             @override
             */

        }, {
            key: "maskEquals",
            value: function maskEquals(mask) {
                return Array.isArray(mask) && this.compiledMasks.every(function (m, mi) {
                    var _mask$mi;

                    return m.maskEquals((_mask$mi = mask[mi]) === null || _mask$mi === void 0 ? void 0 : _mask$mi.mask);
                });
            }
        }]);

        return MaskedDynamic;
    }(Masked);
    MaskedDynamic.DEFAULTS = {
        dispatch: function dispatch(appended, masked, flags) {
            if (!masked.compiledMasks.length) return;
            var inputValue = masked.rawInputValue; // simulate input

            var inputs = masked.compiledMasks.map(function (m, index) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
                m.append(appended, flags);
                var weight = m.rawInputValue.length;
                return {
                    weight: weight,
                    index: index
                };
            }); // pop masks with longer values first

            inputs.sort(function (i1, i2) {
                return i2.weight - i1.weight;
            });
            return masked.compiledMasks[inputs[0].index];
        }
    };
    IMask.MaskedDynamic = MaskedDynamic;

    /** Mask pipe source and destination types */

    var PIPE_TYPE = {
        MASKED: 'value',
        UNMASKED: 'unmaskedValue',
        TYPED: 'typedValue'
    };
    /** Creates new pipe function depending on mask type, source and destination options */

    function createPipe(mask) {
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIPE_TYPE.MASKED;
        var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIPE_TYPE.MASKED;
        var masked = createMask(mask);
        return function (value) {
            return masked.runIsolated(function (m) {
                m[from] = value;
                return m[to];
            });
        };
    }
    /** Pipes value through mask depending on mask type, source and destination options */

    function pipe(value) {
        for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            pipeArgs[_key - 1] = arguments[_key];
        }

        return createPipe.apply(void 0, pipeArgs)(value);
    }
    IMask.PIPE_TYPE = PIPE_TYPE;
    IMask.createPipe = createPipe;
    IMask.pipe = pipe;

    try {
        globalThis.IMask = IMask;
    } catch (e) {}

    exports.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
    exports.HTMLMaskElement = HTMLMaskElement;
    exports.InputMask = InputMask;
    exports.MaskElement = MaskElement;
    exports.Masked = Masked;
    exports.MaskedDate = MaskedDate;
    exports.MaskedDynamic = MaskedDynamic;
    exports.MaskedEnum = MaskedEnum;
    exports.MaskedFunction = MaskedFunction;
    exports.MaskedNumber = MaskedNumber;
    exports.MaskedPattern = MaskedPattern;
    exports.MaskedRange = MaskedRange;
    exports.MaskedRegExp = MaskedRegExp;
    exports.PIPE_TYPE = PIPE_TYPE;
    exports.createMask = createMask;
    exports.createPipe = createPipe;
    exports["default"] = IMask;
    exports.pipe = pipe;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=imask.js.map
